import { OrderTableHeader } from "../../../Component/style/orderTable_style2";
import { CLAIM_PROCESSING_STATES, CLAIM_REFUND_STATES, clampClaimQuantity } from '../../../Component/UI/orderClaimProgress';
import OrderActionToast from './Component/OrderActionToast';
import OrderClaimList from './Component/OrderClaimList';
import { downloadSellerGiftHistory } from '../../../Component/tool/seller_gifts_download';
import SellerGiftList from '../../../Component/UI/SellerGiftList';
import { withSellerGifts } from '../../../Component/sellerGifts';
import { downloadLiveProductSales } from '../../../Component/tool/live_product_sales_download';
import BankCashReceiptList from './Component/BankCashReceiptList';
import SendPaymentModal from '../LiveList/Modal/SendPaymentModal';
import useRefundTestOrder, { TEST_DETAIL_SEQ, TEST_ORDER_SEQ } from "./Component/useRefundTestOrder";
import RefundAmountFields, { validRefundAmounts, automaticRefundAmount } from "./Component/RefundAmountFields";
import AdminCancellationDialog from "../../../Component/UI/AdminCancellationDialog";
import OrderClaimDialog from '../../../Component/UI/OrderClaims';
import BankRefundDialog from './Modal/BankRefundDialog';
/* eslint-disable react/jsx-pascal-case */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import { OrderList } from "../../../Component/Interface/Order";
import url, { SERVER_ADDRESS } from "../../../Component/server";
import { fontStyles } from "../../../Component/style/admin_font";
import {
  CenterView,
  CheckBox,
  AdminIcon as Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import { XLSX_down_ } from "../../../Component/tool/xlsx_download";
import { downloadPurchaseOrder } from "../../../Component/tool/purchase_order_download";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import AdminPageHeader, { AdminActionButton } from "../../../Component/UI/AdminPageHeader";
import ConfirmModal from "../../../Component/UI/ConfirmModal";
import Order_all from "./Component/Order_all";
import Order_cancel from "./Component/Order_cancel";
import Order_paydeil from "./Component/Order_paydeil";
import Order_refound from "./Component/Order_refound";
import Order_select_menu, { ORDER_PAGES } from "./Component/Order_select_menu";
import No_stock from "./Modal/No_stock";
import Product_list from "./Modal/Product_list";
import OrderBatchMemoModal from "./Modal/OrderBatchMemoModal";

import DepositExcelImport from './Component/DepositExcelImport';
import DeliveryExcelGuide, { DeliveryExcelErrors, DeliveryExcelFailure, ExcelButton } from './Component/DeliveryExcelGuide';

const pages = ORDER_PAGES;
const primaryStatusByPage: Record<string, string> = {
  'payment-wait': '결제완료', 'payment-done': '발주완료',
  'order-done': '배송중', shipping: '배송완료',
};
const isCount = (value: unknown) => (typeof value === "number" || (typeof value === "string" && value.trim() !== ""))
  && Number.isInteger(Number(value)) && Number(value) >= 0;
const orderActionError = (error: any, fallback: string) => {
  const message = error?.response?.data?.message;
  return typeof message === "string" ? message : Array.isArray(message) ? message.join(" ") : error?.message || fallback;
};
type DeliveryQueryStatus = { enabled: boolean; next_allowed_at: string | null; job_id: string | null;
  job_state: string | null; result: { checked: number; changed: number; failed: number; quota_exhausted: boolean } | null };
const batchDateLabel = (value: unknown) => {
  if (typeof value !== "string" || value.trim() === "") return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Seoul", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
  }).formatToParts(date);
  const part = (type: string) => parts.find(item => item.type === type)?.value;
  return `${part("year")}.${part("month")}.${part("day")} ${part("hour")}:${part("minute")}:${part("second")}`;
};

/**
 * 발주 회차(N차) — 발주완료 탭 서브탭에 쓰는 배치 단위.
 * 서버에 저장된 회차와 현재 발주완료 주문 집계.
 */
interface OrderBatch {
  round: number;
  name: string;
  createdAt: string;
  memo: string | null;
  procurementSeq?: number;
  userCount: number;
  orderCount: number;
  totalCount: number;
  completedCount: number;
  snapshotAvailable?: boolean;
}

// 서브탭 메모 아이콘 — 별도 png 에셋 없어 인라인 svg로(연필=메모 없음/말풍선=메모 있음, 목업 참고).
const PencilIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 20l1.3-4.6L15.8 4.9l3.3 3.3L8.6 18.7 4 20z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);
const ChatIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 5h16v10.5H9.2L4 20V5z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

type RefundQuote = { orders: { order_seq: number; goods_amount: number; delivery_eligible_amount: number; delivery_amount: number; total_amount: number }[]; total_amount: number };

const Orderlist = ({ adminPermissions = [] }: { adminPermissions?: string[] }) => {
  const [cashReceiptsOpen, setCashReceiptsOpen] = useState(false);
  const [paymentNoticeOpen, setPaymentNoticeOpen] = useState(false);
  const closeCashReceipts = useCallback(() => setCashReceiptsOpen(false), []);
  const canManageOrders = adminPermissions.includes("order_manage");
  const [claimOrder,setClaimOrder]=useState<number|null>(null);
  const [claimActionContainer,setClaimActionContainer]=useState<HTMLDivElement|null>(null);
  const [claimSelectedSeqs,setClaimSelectedSeqs]=useState<number[]|undefined>();
  const [claimItemSeqs,setClaimItemSeqs]=useState<number[]|undefined>();
  const [bankRefundOrder, setBankRefundOrder] = useState<number | null>(null);
  const closeBankRefund = React.useCallback(() => setBankRefundOrder(null), []);
  const Navigate = useNavigate();
  const { page: requestedPage = "" } = useParams();
  const selectedPage = pages.find(item => item.key === requestedPage) || pages[0];
  const page = selectedPage.key;
  const pagename = selectedPage.name;

  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (requestedPage !== page) Navigate(`/admin/orderlist/${page}?${searchParams.toString()}`, { replace: true });
  }, [requestedPage, page, searchParams, Navigate]);
  const liveSeq = Number(searchParams.get("live_seq")) || 0;
  useEffect(() => { setPaymentNoticeOpen(false); setCashReceiptsOpen(false); }, [page, liveSeq]);
  const testOrder = useRefundTestOrder(liveSeq);
  const mounted = useRef(false);
  const listRequest = useRef(0), batchRequest = useRef(0);
  const operation = useRef<string | null>(null);
  const context = `${liveSeq}:${page}`;
  const contextRef = useRef(context);
  contextRef.current = context;
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; listRequest.current += 1; batchRequest.current += 1; };
  }, []);
  const [liveInfo, setLiveInfo] = useState({ title: "방송을 선택해주세요", start: "", end: "", img: "" });
  useEffect(() => {
    let active = true;
    setLiveInfo({ title: liveSeq ? "방송 정보 확인 중" : "방송을 선택해주세요", start: "", end: "", img: "" });
    if (liveSeq) api.get(url.Communication_url.get_live_info, { params: { seq: liveSeq } }).then(({ data }) => {
      if (!active) return;
      setLiveInfo({ title: data.live_title, start: data.live_start || "", end: data.live_finish || "",
        img: data.live_img ? (data.live_img.startsWith("http") ? data.live_img : SERVER_ADDRESS + "openfile/" + data.live_img) : "" });
    }).catch(() => { if (active) setLiveInfo({ title: "방송 정보를 불러오지 못했습니다", start: "", end: "", img: "" }); });
    return () => { active = false; };
  }, [liveSeq]);

  const menuList = ["결제완료", "발주완료", "배송중", "배송완료"];
  // 결제완료·발주완료 탭에서 "결제대기"로 되돌리는 옵션 추가 — 잘못된 상태를 되돌리는 용도.
  // 각 탭 자기 자신은 어차피 pagename===data로 숨겨지니 목록에 같이 둬도 안전.
  const statusMenuList =
    pagename === "결제완료" || pagename === "발주완료" || pagename === "배송중" || pagename === "배송완료" || pagename === "주문취소" || pagename === "사고처리"
      ? ["결제대기", ...menuList]
      : menuList;
  const show_엑셀업로드 = page === "order-done";
  const show_엑셀내보내기 = page !== "all";
  const show_삭제 = page === "cancel";

  const menuRef = useRef<{ get_order_count: () => void } | null>(null);
  const cnt_reload = () => {
    if (menuRef.current) {
      menuRef.current.get_order_count();
    }
  };

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number | 'all'>(100);
  const requestedPageNumber = useRef(1);
  const orderScrollRef = useRef<HTMLDivElement>(null);
  const batchMatchingOrders = useRef<OrderList[]>([]);

  const [pre_search_value, setPre_Search_value] = useState("");
  const [search_key, setSearch_key] = useState("order_name");
  const [searchKeyDraft, setSearchKeyDraft] = useState("order_name");
  const [search_value, setSearch_value] = useState("");
  const [search_item, setSearch_item] = useState<string[]>([]);
  const [productNames, setProductNames] = useState<string[]>([]);

  const [giftRevision, setGiftRevision] = useState(0);
  const [claimStatus,setClaimStatus]=useState('');
  const [claimRefundStatus,setClaimRefundStatus]=useState('');
  const [claimKind, setClaimKind] = useState('');
  const [transferStatus, setTransferStatus] = useState('');
  const [dateType, setDateType] = useState('order');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [paymentMethod, setPaymentMethod] = useState<'' | 'pg' | 'bank'>(searchParams.get('bank_pending') === 'true' ? 'bank' : '');
  const [bankPending, setBankPending] = useState(searchParams.get('bank_pending') === 'true');
  const [trackingNumber, setTrackingNumber] = useState<'' | 'true' | 'false'>('');
  const trackingFilter = page === 'order-done' ? trackingNumber : '';
  const orderFilters = { ...(startDate && { start_dt: startDate }), ...(endDate && { end_dt: endDate }), ...((startDate || endDate) && { date_type: dateType }),
    ...(page === 'claims' && claimKind && { claim_kind: claimKind }), ...(page === 'claims' && transferStatus && { transfer_status: transferStatus }), ...(page==='claims'&&claimStatus?{claim_processing:claimStatus}:{}), ...(page==='claims'&&claimRefundStatus?{claim_refund_status:claimRefundStatus}:{}), ...(paymentMethod && { payment_method: paymentMethod }), ...(bankPending && { bank_pending: true }),
    ...(trackingFilter !== '' && { has_tracking_number: trackingFilter === 'true' }) };
  const [total, setTotal] = useState(0);
  const [list, setList] = useState<OrderList[]>([]);
  const [listError, setListError] = useState("");
  const [batchError, setBatchError] = useState("");
  const [batchLoading, setBatchLoading] = useState(false);
  const [actionError, setActionError] = useState<string | { uploadFailures: DeliveryExcelFailure[] }>("");
  const [actionMessage, setActionMessage] = useState("");
  const [countLoadError,setCountLoadError]=useState("");
  const [giftLoadError,setGiftLoadError]=useState("");
  const loadingError=listError||countLoadError||giftLoadError;
  const dismissActionMessage = useCallback(() => setActionMessage(""), []);
  const [deliveryStatus, setDeliveryStatus] = useState<DeliveryQueryStatus | null>(null);
  const [deliveryBusy, setDeliveryBusy] = useState(false);
  const finishedDeliveryJob = useRef<string | null>(null);
  const [orderBatches, setOrderBatches] = useState<OrderBatch[]>([]);
  const [selectedBatchRound, setSelectedBatchRound] = useState<number | "all">("all");
  const [batchView, setBatchView] = useState<'history' | 'pending'>('history');
  const isProcurementHistory = page === "order-done" && batchView === 'history';
  const giftProcurementSeq = isProcurementHistory && selectedBatchRound !== 'all' ? orderBatches.find(batch => batch.round === selectedBatchRound)?.procurementSeq : undefined;
  const [stockModal, setStockModal] = useState(false);
  const handleStockModal = () => setStockModal(!stockModal);
  const [open_productList, setOpen_productList] = useState(false);
  const handleOpen_productList = () => setOpen_productList(!open_productList);

  const setting_search_key = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setSearchKeyDraft(e.target.value);
  const setting_pre_search_value = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPre_Search_value(e.target.value);
  const keyPress_keyword = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      if (e.nativeEvent.isComposing) return;
      search(e.currentTarget.value);
    }
  };

  const del_search_value = () => setSearch_value("");
  const del_search_item = (name: string) => setSearch_item(items => items.filter(item => item !== name));
  const reset = () => {
    setPaymentMethod(''); setBankPending(false); setTrackingNumber('');
    setDateType('order'); setStartDate(''); setEndDate(''); setClaimKind(''); setClaimStatus(''); setClaimRefundStatus(''); setTransferStatus(''); setCurrentPage(1);
    setPre_Search_value("");
    setSearch_value(""); setSearch_item([]);
  };

  const data_reset = (search_reset: boolean) => {
    // 언제 수정하지...
    setCurrentPage(1); // 1페이지로
    // setLoading(true); // loading
    // setList([]); // list 초기화
    setSelectOrder([]); // checkbox 초기화
    setSelect_status("");
    if (search_reset) {
      // 검색어 초기화
      setPre_Search_value("");
      setSearch_value("");
      setSearch_item([]);
    }
  };
  const go_page = useCallback((key: string) => {
    listRequest.current += 1;
    batchRequest.current += 1;
    setSelectedBatchRound("all");
    data_reset(true);
    Navigate(`/admin/orderlist/${key}?live_seq=${liveSeq}`);
  }, [liveSeq, Navigate]);

  const get_order_list = async (currentPageNum: number, del?: true) => {
    requestedPageNumber.current = currentPageNum;
    if (!liveSeq) { setList([]); setTotal(0); setProductNames([]); return; }
    if (startDate && endDate && startDate > endDate) { listRequest.current += 1; setLoading(false); setList([]); setTotal(0); setProductNames([]); setListError('시작일은 종료일보다 늦을 수 없습니다.'); return; }
    if (currentPageNum === 1 && currentPage !== 1) setCurrentPage(1);
    const request = ++listRequest.current;
    const currentContext = context;
    const menu = pages.find((data) => data.key === page);
    setLoading(true);
    try {
      const isBatch = page === "order-done" && selectedBatchRound !== "all";
      const res = isBatch
        ? await api.get(url.Communication_url.procurement_list, {
          params: { live_seq: liveSeq, round: selectedBatchRound, order_status: isProcurementHistory ? "전체" : "발주완료", ...orderFilters },
        })
        : await api.get(url.Communication_url.get_order_list, {
        params: {
          ...orderFilters,
          live_seq: liveSeq,
          order_status: isProcurementHistory ? "전체" : menu?.name,
          ...(isProcurementHistory && { procurement_only: true }),
          include_product_names: true,
          current_page: currentPageNum,
          ...(pageSize !== 'all' && { per_page: pageSize }),
          ...(search_value !== "" && {
            search_key: search_key,
            search_value: search_value,
          }),
          ...(search_item.length > 0 && {
            product_names: search_item,
          }),
        },
      });
      if (!mounted.current || currentContext !== contextRef.current || request !== listRequest.current) return;
      if (!Array.isArray(res.data?.orderList) || !isCount(res.data.total)) {
        throw new Error("Invalid order list response");
      }
      let datalist: OrderList[] = res.data.orderList;
      if (isBatch) {
        datalist = datalist.filter(order => !search_value || search_key === "product_name" || search_key === 'detail_seq' || (search_key === 'order_seq'
          ? String(order.seq) === search_value.trim() : String((order as any)[search_key] ?? "").includes(search_value)));
        setProductNames([...new Set(datalist.flatMap(order => order.order_details.map(detail => detail.product_name)))].sort());
        datalist = datalist.map(order => ({ ...order, order_details: order.order_details.filter(detail =>
          (search_item.length === 0 || search_item.includes(detail.product_name))
          && (search_key !== 'detail_seq' || !search_value || String(detail.detail_seq) === search_value.trim())
          && (search_key !== "product_name" || !search_value || detail.product_name.toLocaleLowerCase().includes(search_value.toLocaleLowerCase()))) }))
          .filter(order => order.order_details.length > 0);
      } else {
        setProductNames(Array.isArray(res.data.productNames) ? res.data.productNames : []);
      }
      const includeTest = !startDate && !endDate && testOrder.matches(pagename) && !isBatch && !bankPending && paymentMethod !== 'bank'
        && (!search_value || (search_key === 'product_name' ? '[테스트] 티셔츠' : String(search_key === 'order_seq' ? testOrder.order.seq : search_key === 'detail_seq' ? TEST_DETAIL_SEQ : (testOrder.order as any)[search_key] || '')).toLocaleLowerCase().includes(search_value.toLocaleLowerCase()))
        && (!search_item.length || search_item.includes('[테스트] 티셔츠'));
      if (includeTest && currentPageNum === 1) datalist = [testOrder.order, ...datalist];
      if (testOrder.matches(pagename)) setProductNames(previous => [...new Set([...previous, '[테스트] 티셔츠'])]);
      const total = (isBatch ? datalist.length : Number(res.data.total)) + (includeTest ? 1 : 0);
      datalist.forEach((order: OrderList) => {
        order.order_details?.forEach((detail: any) => {
          if (detail.excess_qty === undefined && detail.over_cnt) {
            detail.excess_qty = Number(detail.over_cnt);
          }
        });
      });
      setListError("");
      setTotal(total);
      const lastPage = pageSize === 'all' ? 1 : Math.max(1, Math.ceil(total / pageSize));
      if (currentPageNum > lastPage) { setList([]); setCurrentPage(lastPage); return true; }
      if (isBatch) {
        batchMatchingOrders.current = datalist;
        if (pageSize !== 'all') datalist = datalist.slice((currentPageNum - 1) * pageSize, currentPageNum * pageSize);
      }
      if (datalist.length === 0) {
        setList([]);
        setLoading(false);
        return true;
      }
      setList(datalist);
      setGiftRevision(value => value + 1);
      return true;
    } catch (error) {
      if (!mounted.current || currentContext !== contextRef.current || request !== listRequest.current) return;
      console.error("주문 데이터 로드 실패:", error);
      setProductNames([]);
      setListError("주문 정보를 불러오지 못했습니다. 다시 시도해주세요.");
      return false;
    } finally {
      if (mounted.current && currentContext === contextRef.current && request === listRequest.current) setLoading(false);
    }
  };
  useEffect(() => {
    data_reset(false);
    setBankRefundOrder(null);
    setList([]); setActionError("");
    get_order_list(1);
    return () => { listRequest.current += 1; };
  }, [page, liveSeq, selectedBatchRound, batchView, search_key, search_value, search_item, paymentMethod, bankPending, claimStatus, claimRefundStatus, claimKind, transferStatus, dateType, startDate, endDate, trackingFilter, testOrder.revision, pageSize]);

  useEffect(() => {
    if (currentPage !== requestedPageNumber.current) {
      get_order_list(currentPage);
    }
  }, [currentPage]);

  useEffect(() => { if (orderScrollRef.current) orderScrollRef.current.scrollTop = 0; }, [currentPage, pageSize, page, search_value, search_item, paymentMethod, claimStatus, claimRefundStatus, claimKind, transferStatus, startDate, endDate, selectedBatchRound]);

  const refreshList = useRef(() => {});
  refreshList.current = () => {
    if (!liveSeq || loading || loading_ || operation.current) return;
    cnt_reload();
    void get_order_list(currentPage);
    if (page === "order-done") void loadOrderBatches();
  };
  useEffect(() => {
    const refresh = () => { if (document.visibilityState !== 'hidden') refreshList.current(); };
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    const timer = window.setInterval(refresh, 120000);
    return () => { window.removeEventListener('focus', refresh); document.removeEventListener('visibilitychange', refresh); window.clearInterval(timer); };
  }, []);

  useEffect(() => {
    if (!canManageOrders || !liveSeq) return;
    let active = true;
    void (async () => {
      try {
        const { data } = await api.get(`${SERVER_ADDRESS}orders/delivery-query-status`);
        if (!active) return;
        setDeliveryStatus(data);
        if (!data?.enabled || (data.next_allowed_at && Date.parse(data.next_allowed_at) > Date.now())) return;
        const started = await api.post(`${SERVER_ADDRESS}orders/delivery-query-admin`, { force: false }, { headers: { 'Content-Type': 'application/json' } });
        if (active && !started.data?.skipped) setDeliveryStatus({ ...data,
          next_allowed_at: started.data.next_allowed_at, job_id: started.data.job_id, job_state: 'waiting', result: null });
      } catch (error) {
        if (active) setActionError('배송조회 상태를 확인하지 못했습니다. 주문 목록은 계속 사용할 수 있습니다.');
      }
    })();
    return () => { active = false; };
  }, [canManageOrders, liveSeq]);

  useEffect(() => {
    const jobId = deliveryStatus?.job_id;
    if (!jobId || !['waiting', 'active', 'delayed'].includes(deliveryStatus?.job_state || '')) return;
    let active = true;
    const check = async () => {
      try {
        const { data } = await api.get(`${SERVER_ADDRESS}orders/delivery-query-status`);
        if (!active || data.job_id !== jobId) return;
        setDeliveryStatus(data);
        if (['completed', 'failed'].includes(data.job_state) && finishedDeliveryJob.current !== jobId) {
          finishedDeliveryJob.current = jobId;
          if (data.job_state === 'completed') {
            const result = data.result;
            setActionMessage(`배송 상태 조회 완료 · 조회 ${result?.checked ?? 0}건 · 변경 ${result?.changed ?? 0}건${result?.failed ? ` · 조회 실패 ${result.failed}건` : ''}${result?.quota_exhausted ? ' · API 사용량 초과' : ''}`);
            refreshList.current();
          } else setActionError('배송 상태 조회를 완료하지 못했습니다. 다시 조회해 주세요.');
        }
      } catch (error) { /* The next poll can retry. */ }
    };
    const timer = window.setInterval(check, 5000);
    return () => { active = false; window.clearInterval(timer); };
  }, [deliveryStatus?.job_id, deliveryStatus?.job_state]);

  const refreshDeliveryNow = async () => {
    if (deliveryBusy || !deliveryStatus?.enabled) return;
    setDeliveryBusy(true); setActionError('');
    try {
      const { data } = await api.post(`${SERVER_ADDRESS}orders/delivery-query-admin`, { force: true }, { headers: { 'Content-Type': 'application/json' } });
      setDeliveryStatus({ enabled: true, next_allowed_at: data.next_allowed_at,
        job_id: data.job_id, job_state: 'waiting', result: null });
      setActionMessage('전체 배송 상태 조회를 시작했습니다. 결과가 반영되면 목록이 갱신됩니다.');
    } catch (error: any) {
      setActionError(error?.response?.data?.message || '배송 상태 조회를 시작하지 못했습니다.');
    } finally { setDeliveryBusy(false); }
  };

  const search = (directValue?: string) => {
    if (operation.current) return;
    const targetValue = directValue !== undefined ? directValue : pre_search_value;

    if (targetValue === "" && search_item.length === 0) {
      alert("검색어를 입력해주세요.");
      return;
    }
    setSearch_key(searchKeyDraft);
    setSearch_value(targetValue.trim());

    // 검색창 인풋 초기화
    setPre_Search_value("");
  };

  const [loading_, setLoading_] = useState(false);
  const [select_status, setSelect_status] = useState("");
  const [selectOrder, setSelectOrder] = useState<number[]>([]);

  // 재고 초과 주문건(시스템 오류) — 결제대기 탭 전용. 서버 주문 상세 기준.
  const [showExcessOnly, setShowExcessOnly] = useState(false);
  const excessOrderCount =
    pagename === "결제대기"
      ? list.filter((order) =>
        order.order_details.some((detail) => (detail.excess_qty ?? 0) > 0)
      ).length
      : 0;
  const displayList = (() => {
    let arr = list;
    if (pagename === "결제대기" && showExcessOnly) {
      arr = arr.filter((order) =>
        order.order_details.some((detail) => (detail.excess_qty ?? 0) > 0)
      );
    }
    return arr;
  })();
  const toggle_excess_only = () => setShowExcessOnly((prev) => !prev);

  // 주문취소 리뷰 모드 — "주문취소" 버튼 클릭 시 바로 상태변경하지 않고, 취소수량/택배비를
  // 건별로 조정한 뒤 "N건 주문취소 완료하기"를 눌러야 최종 확정되는 흐름.
  // 목업: Docs/디자인/{주문내역_결제취소, 주문취소 여부/완료, 환불 리스트 삭제 여부/완료}.png
  const [cancelMode, setCancelMode] = useState(false);
  const [cancelQtyMap, setCancelQtyMap] = useState<Record<number, number>>({});
  const [refundAmounts, setRefundAmounts] = useState<Record<number, string>>({});
  const [cancelDeliveryMap, setCancelDeliveryMap] = useState<Record<number, boolean>>({});
  const [removeTargetSeq, setRemoveTargetSeq] = useState<number | null>(null);
  const [showRemoveDone, setShowRemoveDone] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const cancelRequest = useRef(crypto.randomUUID());
  const [showCancelDone, setShowCancelDone] = useState(false);

  // 결제대기에서만 "주문취소"(아직 결제 전) — 그 외 탭은 전부 "환불처리"(이미 결제됨)로 취급.
  const isRefundFlow = pagename !== "결제대기";
  const cancelFlowStatus = isRefundFlow ? "환불처리" : "주문취소";
  const [refundReviewOrders, setRefundReviewOrders] = useState<OrderList[]>([]);
  const refundSource = isRefundFlow && refundReviewOrders.length ? refundReviewOrders : list;
  const refundAmountItems = refundSource.flatMap(order => order.order_details.filter(detail => selectOrder.includes(detail.detail_seq)).map(detail => {
    const quantity = cancelQtyMap[detail.detail_seq] ?? Math.max(0, detail.order_cnt - Number(detail.cancel_cnt || 0));
    return { seq: detail.detail_seq, name: detail.product_name + (detail.option_name ? ` / ${detail.option_name}` : ''), quantity,
      maximum: automaticRefundAmount(detail, quantity), maxQuantity: Math.max(0, detail.order_cnt - Number(detail.cancel_cnt || 0)) };
  }));

  const refundInputsValid = refundAmountItems.length > 0 && refundAmountItems.every(item => Number.isSafeInteger(item.quantity)
    && item.quantity > 0 && item.quantity <= item.maxQuantity!) && validRefundAmounts(refundAmountItems, refundAmounts);
  const refundPreviewOrders = refundSource.map(order => ({ order_seq: order.seq,
    delivery_cancel: cancelDeliveryMap[order.seq] ?? true,
    items: order.order_details.filter(detail => selectOrder.includes(detail.detail_seq)).map(detail => ({
      detail_seq: detail.detail_seq, cancel_cnt: cancelQtyMap[detail.detail_seq] ?? Math.max(0, detail.order_cnt - Number(detail.cancel_cnt || 0)),
      ...(refundAmounts[detail.detail_seq] !== undefined && refundAmounts[detail.detail_seq] !== '' ? { refund_amount: Number(refundAmounts[detail.detail_seq]) } : {}),
    })),
  })).filter(order => order.items.length > 0);
  const refundPreviewKey = JSON.stringify(refundPreviewOrders);
  const needsRefundQuote = showCancelConfirm && isRefundFlow && !select_status && refundInputsValid;
  const [refundQuoteResult, setRefundQuoteResult] = useState<{ key: string; data?: RefundQuote; error?: string } | null>(null);
  const [refundQuoteRetry, setRefundQuoteRetry] = useState(0);
  const currentRefundQuote = needsRefundQuote && refundQuoteResult?.key === refundPreviewKey ? refundQuoteResult.data : undefined;
  const refundQuoteError = needsRefundQuote && refundQuoteResult?.key === refundPreviewKey ? refundQuoteResult.error : undefined;
  useEffect(() => {
    setRefundQuoteResult(null);
    if (!needsRefundQuote) return;
    let active = true;
    const orders = JSON.parse(refundPreviewKey);
    if (orders.length === 1 && orders[0].order_seq === TEST_ORDER_SEQ) {
      const goods = orders[0].items.reduce((sum: number, item: any) => sum + (item.refund_amount ?? item.cancel_cnt * 10000), 0);
      setRefundQuoteResult({ key: refundPreviewKey, data: { orders: [{ order_seq: TEST_ORDER_SEQ, goods_amount: goods,
        delivery_eligible_amount: 0, delivery_amount: 0, total_amount: goods }], total_amount: goods } });
      return;
    }
    void api.post(`${SERVER_ADDRESS}orders/refund-preview`, { orders }).then(({ data }) => {
      if (!active) return;
      if (!Array.isArray(data?.orders) || data.orders.length !== orders.length
        || data.orders.some((quote: any, index: number) => quote.order_seq !== orders[index].order_seq
          || ![quote.goods_amount, quote.delivery_eligible_amount, quote.delivery_amount, quote.total_amount].every(value => Number.isSafeInteger(value) && value >= 0)
          || quote.delivery_amount > quote.delivery_eligible_amount || quote.total_amount !== quote.goods_amount + quote.delivery_amount)
        || data.total_amount !== data.orders.reduce((sum: number, quote: any) => sum + quote.total_amount, 0)) throw new Error('Invalid refund preview');
      setRefundQuoteResult({ key: refundPreviewKey, data });
    }).catch(() => { if (active) setRefundQuoteResult({ key: refundPreviewKey, error: '환불 금액을 확인하지 못했습니다. 다시 계산해주세요.' }); });
    return () => { active = false; };
  }, [needsRefundQuote, refundPreviewKey, refundQuoteRetry]);

  const cannotCancelItem = (order: OrderList, detail: OrderList['order_details'][number]) => {
    const payment = order.payment_summary;
    return detail.order_status !== '결제대기' || Number(detail.cancel_cnt || 0) >= detail.order_cnt
      || !!(detail.payment_method === 'bank' ? payment?.bank_paid || payment?.bank_paid_at : payment?.pg_paid || payment?.pg_paid_at);
  };
  const cancelSelectionBlocked = page !== 'payment-wait' || displayList.some(order => order.order_details.some(detail =>
    (select_status !== '' || selectOrder.includes(detail.detail_seq)) && cannotCancelItem(order, detail)));
  const openReturnReview = async () => {
    if (!canManageOrders || loading_ || loading || operation.current || listError) return;
    if (!selectOrder.length && !select_status) { setShowSelectRequired(true); return; }
    setActionError(''); setLoading_(true);
    try {
      const orders = select_status ? await fetchAllMatchingOrders() : displayList;
      const targets = orders.map(order => ({ ...order, order_details: order.order_details.filter(detail => select_status || selectOrder.includes(detail.detail_seq)) }))
        .filter(order => order.order_details.length);
      if (targets.length !== 1) { setActionError('반품은 한 주문씩 처리할 수 있습니다. 같은 주문의 상품을 선택해주세요.'); return; }
      if (targets[0].seq === TEST_ORDER_SEQ) { setActionError('테스트 주문은 배송완료·환불처리 시험에 사용해주세요.'); return; }
      setClaimItemSeqs(targets[0].order_details.map(detail => detail.detail_seq)); setClaimOrder(targets[0].seq);
    } catch (error: any) { setActionError(orderActionError(error, '반품할 주문을 불러오지 못했습니다.')); }
    finally { setLoading_(false); }
  };
  const enterCancelReviewMode = async () => {
    if (!canManageOrders) return;

    if (!selectOrder.length && !select_status) { setShowSelectRequired(true); return; }
    if (loading_) return;
    if (!isRefundFlow && cancelSelectionBlocked) { setActionError('결제대기 상품만 주문 취소할 수 있습니다. 결제된 상품은 반품·환불처리를 이용해주세요.'); return; }
    if (isRefundFlow) {
      let targets = list;
      if (select_status) {
        if (testOrder.matches(select_status) && list.some(order => order.seq !== TEST_ORDER_SEQ)) { setActionError('테스트 주문과 실제 주문은 따로 선택해 처리해주세요.'); return; }
        setLoading_(true);
        try { targets = testOrder.matches(select_status) ? [testOrder.order] : await fetchAllMatchingOrders(); }
        catch (error: any) { setActionError(error.message || '환불할 주문을 불러오지 못했습니다.'); return; }
        finally { setLoading_(false); }
      }
      const selected = select_status ? targets.flatMap(order => order.order_details.map(detail => detail.detail_seq)) : selectOrder;
      targets = targets.map(order => ({ ...order, order_details: order.order_details.filter(detail => selected.includes(detail.detail_seq)) }))
        .filter(order => order.order_details.length);
      if (selected.includes(TEST_DETAIL_SEQ) && selected.length > 1) { setActionError('테스트 주문과 실제 주문은 따로 선택해 처리해주세요.'); return; }
      setSelectOrder(selected); setSelect_status(''); setRefundReviewOrders(targets);
      setCancelQtyMap(Object.fromEntries(targets.flatMap(order => order.order_details.map(detail => [detail.detail_seq, detail.order_cnt - Number(detail.cancel_cnt || 0)]))));
      setCancelDeliveryMap({});
      setRefundAmounts({}); setActionError(''); setCancelReason(''); cancelRequest.current = crypto.randomUUID();
      setCancelMode(false); setShowCancelConfirm(true); return;
    }
    // "모든 주문 선택"(검색조건 기반 전체선택)은 건별 리뷰 UI와 안 맞아 기존 즉시처리 흐름 유지.
    if (select_status !== "") { setActionError(''); setCancelReason(''); cancelRequest.current = crypto.randomUUID(); setShowCancelConfirm(true); return; }
    if (selectOrder.length === 0) return;

    const qtyMap: Record<number, number> = {};
    const deliveryMap: Record<number, boolean> = {};
    list.forEach((order) => {
      let orderHasSelected = false;
      order.order_details.forEach((detail) => {
        if (selectOrder.includes(detail.detail_seq)) {
          qtyMap[detail.detail_seq] = Math.max(0, detail.order_cnt - (detail.cancel_cnt || 0));
          orderHasSelected = true;
        }
      });
      if (orderHasSelected) deliveryMap[order.seq] = true;
    });
    setRefundAmounts({});
    setCancelQtyMap(qtyMap);
    setCancelDeliveryMap(deliveryMap);
    setCancelMode(true);
  };

  const exitCancelReviewMode = () => {
    setCancelMode(false);
    setCancelQtyMap({});
    setCancelDeliveryMap({});
  };

  // 리뷰 모드 중 리스트 = 선택된 detail만 필터링(목업: 체크된 항목만 노출).
  const cancelReviewList = cancelMode
    ? list
      .map((order) => ({
        ...order,
        order_details: order.order_details.filter((d) =>
          selectOrder.includes(d.detail_seq)
        ),
      }))
      .filter((order) => order.order_details.length > 0)
    : displayList;

  const changeCancelQty = (detail_seq: number, nextQty: number) => {
    const detail = list
      .flatMap((o) => o.order_details)
      .find((d) => d.detail_seq === detail_seq);
    const max = detail ? Math.max(0, detail.order_cnt - (detail.cancel_cnt || 0)) : 0;
    const clamped = Math.min(max, Math.max(1, nextQty));
    setCancelQtyMap((prev) => ({ ...prev, [detail_seq]: clamped }));
  };

  const toggleCancelDelivery = (orderSeq: number) => {
    setCancelDeliveryMap((prev) => ({ ...prev, [orderSeq]: !prev[orderSeq] }));
  };

  // 택배비 헤더 전체선택 — 지금 리뷰 리스트에 보이는 order 전부를 한 번에 체크/해제.
  const isAllCancelDeliveryChecked =
    cancelReviewList.length > 0 &&
    cancelReviewList.every((order) => cancelDeliveryMap[order.seq] ?? true);
  const setAllCancelDelivery = (checked: boolean) => {
    setCancelDeliveryMap((prev) => {
      const copy = { ...prev };
      cancelReviewList.forEach((order) => {
        copy[order.seq] = checked;
      });
      return copy;
    });
  };

  // 체크 해제는 바로 안 빼고 "환불 리스트 삭제" 확인 모달을 먼저 띄운다.
  const requestRemoveFromCancel = (detail_seq: number) =>
    setRemoveTargetSeq(detail_seq);

  const confirmRemoveFromCancel = () => {
    if (removeTargetSeq === null) return;
    setSelectOrder((prev) => prev.filter((s) => s !== removeTargetSeq));
    setCancelQtyMap((prev) => {
      const copy = { ...prev };
      delete copy[removeTargetSeq];
      return copy;
    });
    setRemoveTargetSeq(null);
    setShowRemoveDone(true);
  };

  // "N건 주문취소/환불처리 완료하기" 클릭 → 여부 확인 모달
  const clickCancelComplete = () => {
    if (!canManageOrders) return;

    if (selectOrder.length === 0) return;
    setActionError(''); setCancelReason(''); cancelRequest.current = crypto.randomUUID(); setShowCancelConfirm(true);
  };

  // 환불은 주문별 부분취소 API, 미결제 취소는 상태변경 API를 사용한다.
  const submitCancelReview = async () => {
    if (!cancelReason.trim() || operation.current || loading_) return;
    if (isRefundFlow && !currentRefundQuote) return;
    if (testOrder.enabled && (selectOrder.includes(TEST_DETAIL_SEQ) || (select_status && testOrder.matches(select_status)))) {
      if (selectOrder.some(seq => seq !== TEST_DETAIL_SEQ) || (select_status && list.some(order => order.seq !== TEST_ORDER_SEQ))) {
        setActionError('테스트 주문과 실제 주문은 따로 선택해 처리해주세요.'); return;
      }
      try {
        if (isRefundFlow) {
          const quantity = cancelQtyMap[TEST_DETAIL_SEQ] ?? (3 - Number(testOrder.order.order_details[0].cancel_cnt || 0));
          const entered = refundAmounts[TEST_DETAIL_SEQ];
          testOrder.refund(quantity, entered === undefined || entered === '' ? quantity * 10000 : Number(entered));
        } else testOrder.changeStatus('주문취소');
        setSelectOrder([]); setSelect_status(''); exitCancelReviewMode(); setShowCancelConfirm(false); go_page(isRefundFlow ? 'refund' : 'cancel');
      } catch (error: any) { setActionError(error.message); }
      return;
    }
    if (select_status) { if (await update_all_order_status(cancelFlowStatus)) setShowCancelConfirm(false); return; }
    operation.current = "cancel"; setLoading_(true);
    try {
      const selected = refundSource.map(order => ({
        order_seq: order.seq,
        delivery_cancel: isRefundFlow ? (cancelDeliveryMap[order.seq] ?? true)
          && (currentRefundQuote?.orders.find(quote => quote.order_seq === order.seq)?.delivery_eligible_amount ?? 0) > 0 : cancelDeliveryMap[order.seq] ?? false,
        ...(isRefundFlow ? { expected_refund_amount: currentRefundQuote?.orders.find(quote => quote.order_seq === order.seq)?.total_amount } : {}),
        items: order.order_details.filter(detail => selectOrder.includes(detail.detail_seq)).map(detail => ({
          detail_seq: detail.detail_seq, cancel_cnt: cancelQtyMap[detail.detail_seq] ?? Math.max(0,detail.order_cnt-Number(detail.cancel_cnt||0)),
          ...(refundAmounts[detail.detail_seq] !== undefined && refundAmounts[detail.detail_seq] !== "" ? { refund_amount: Number(refundAmounts[detail.detail_seq]) } : {}),
        })),
      })).filter(order => order.items.length > 0);
      const { data } = await api.patch(
        url.Communication_url.order_detail_update_cancel,
        { orders: selected, request_id: cancelRequest.current, reason: cancelReason.trim() },
        { headers: { "Content-Type": "application/json" } },
      );
      if (Number(data.fail) > 0) {
        const failedOrders = new Set<number>((data.failures || []).map((failure: any) => Number(failure.order_seq)));
        if (failedOrders.size) setSelectOrder(previous => previous.filter(seq => list.some(order => failedOrders.has(order.seq) && order.order_details.some(detail => detail.detail_seq === seq))));
        cnt_reload();
        const reasons = (data.failures || []).filter((failure: any) => typeof failure.message === "string").map((failure: any) => `주문 ${failure.order_seq}: ${failure.message}`).join(" ");
        throw new Error(`처리 성공 ${data.success}건, 실패 ${data.fail}건입니다. 목록을 확인해주세요.${reasons ? ` ${reasons}` : ""}`);
      }
      cnt_reload();
      get_order_list(1);
      setSelectOrder([]);
      exitCancelReviewMode();
      setShowCancelConfirm(false);
      setShowCancelDone(true);
    } catch (error: any) {
      console.error(`${cancelFlowStatus} 실패:`, error);
      setActionError(error?.response?.data?.message || error.message || "처리 중 오류가 발생했습니다.");
      if (isRefundFlow) { setRefundQuoteResult(null); setRefundQuoteRetry(value => value + 1); }
    } finally {
      operation.current = null; setLoading_(false);
    }
  };

  // 주문건 미선택 시 경고 모달 (목업: 주문건 미선택 시.png) — 기존엔 조용히 return만 했음.
  const [showSelectRequired, setShowSelectRequired] = useState(false);

  // 발주 회차(N차) 관련 나머지 상태 — orderBatches/selectedBatchRound는 displayList 계산 때문에
  // 위쪽(showExcessOnly 근처)으로 옮겨둠, 여긴 모달/보류값만.
  const [memoModalRound, setMemoModalRound] = useState<number | null>(null);
  const [showPurchaseOrderDone, setShowPurchaseOrderDone] = useState(false);
  const [completionSaving, setCompletionSaving] = useState(false);
  const [pendingProcurementRound, setPendingProcurementRound] = useState<number | null>(null);
  // 상태변경 후 list가 reload되면 해당 탭에서 사라지므로(다른 상태로 이동), 발주서 다운용으로
  // reload 전 시점의 주문 원본을 통째로 들고 있는다(seq만 저장해서 나중에 list에서 재조회하면 못 찾음).
  const pendingPurchaseOrdersRef = useRef<OrderList[]>([]);


  const loadOrderBatches = async () => {
    if (!liveSeq) return;
    const request = ++batchRequest.current, currentContext = context;
    setBatchLoading(true); setBatchError("");
    try {
      const res = await api.get(url.Communication_url.procurement_load, { params: { live_seq: liveSeq } });
      if (!mounted.current || currentContext !== contextRef.current || request !== batchRequest.current) return;
      if (Array.isArray(res.data) && res.data.every((r: any) => Number.isInteger(r.round) && r.round > 0
        && isCount(r.user_count) && isCount(r.cnt) && isCount(r.total_count) && isCount(r.completed_count)
        && Number(r.completed_count) <= Number(r.total_count))) {
        const loadedBatches: OrderBatch[] = res.data.map((r: any) => ({
          round: r.round,
          name: r.name || `${r.round}차 발주`,
          createdAt: batchDateLabel(r.created_at),
          memo: r.memo ?? null,
          procurementSeq: r.procurement_seq,
          userCount: Number(r.user_count),
          orderCount: Number(r.cnt),
          totalCount: Number(r.total_count),
          completedCount: Number(r.completed_count),
          snapshotAvailable: r.snapshot_available === true,
        }));
        setOrderBatches(loadedBatches);
      } else throw new Error("Invalid procurement response");
    } catch (e) {
      if (mounted.current && currentContext === contextRef.current && request === batchRequest.current) {
        setBatchError("발주 회차를 불러오지 못했습니다. 다시 시도해주세요.");
      }
    } finally {
      if (mounted.current && currentContext === contextRef.current && request === batchRequest.current) setBatchLoading(false);
    }
  };

  useEffect(() => {
    setOrderBatches([]); setSelectedBatchRound("all"); setBatchError("");
    if (page === "order-done") loadOrderBatches();
    return () => { batchRequest.current += 1; };
  }, [liveSeq, page]);

  const matchingParams = () => ({
    ...(isProcurementHistory && { procurement_only: true }),
    ...orderFilters,
    live_seq: liveSeq,
    ...(search_value && { search_key, search_value }),
    ...(search_item.length > 0 && { product_names: search_item }),
  });
  const fetchAllMatchingOrders = async (): Promise<OrderList[]> => {
    const currentContext = context;
    if (page === "order-done" && selectedBatchRound !== "all") return batchMatchingOrders.current;
    const result: OrderList[] = [];
    for (let current_page = 1; ; current_page += 1) {
      const { data } = await api.get(url.Communication_url.get_order_list, {
        params: { ...matchingParams(), order_status: isProcurementHistory ? "전체" : pagename, current_page, per_page: 50 },
      });
      if (!mounted.current || currentContext !== contextRef.current) throw new Error("화면이 변경되어 작업을 중단했습니다.");
      if (!Array.isArray(data?.orderList) || !isCount(data.total)) throw new Error("주문 정보를 확인하지 못했습니다.");
      if (data.orderList.some((item: OrderList) => result.some(previous => previous.seq === item.seq))) throw new Error("주문 목록이 변경되었습니다. 다시 불러온 뒤 시도해주세요.");
      result.push(...data.orderList);
      if (result.length >= Number(data.total)) break;
      if (data.orderList.length === 0) throw new Error("전체 주문을 불러오지 못했습니다. 다시 시도해주세요.");
    }
    return result;
  };

  // "발주서 다운" — 체크된 항목 있으면 그 항목만, 없으면 지금 보고 있는 서브탭(전체/N차) 전체 재다운로드.
  const downloadProcurementFile = async (original: boolean) => {
    if (operation.current || selectedBatchRound === 'all' || !liveSeq) return;
    operation.current = 'export-original'; setLoading_(true); setActionError('');
    const currentContext = context;
    try {
      const response = await api.get(original ? url.Communication_url.procurement_excel_raw : url.Communication_url.procurement_excel, {
        params: { live_seq: liveSeq, round: selectedBatchRound }, responseType: 'blob',
      });
      if (!mounted.current || currentContext !== contextRef.current) return;
      const disposition = response.headers['content-disposition'] || '';
      const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
      const captured = orderBatches.find(batch => batch.round === selectedBatchRound)?.snapshotAvailable;
      const filename = encoded ? decodeURIComponent(encoded) : `${selectedBatchRound}차발주_${original ? (captured ? '발주원본' : '현재자료_원본없음') : '발주서'}.xlsx`;
      const address = URL.createObjectURL(response.data);
      const anchor = document.createElement('a'); anchor.href = address; anchor.download = filename;
      document.body.appendChild(anchor); anchor.click(); anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(address), 1000);
    } catch (cause) {
      if (mounted.current && currentContext === contextRef.current) setActionError('발주 자료를 내려받지 못했습니다. 다시 시도해주세요.');
    } finally { operation.current = null; if (mounted.current) setLoading_(false); }
  };
  const downloadProcurementOriginal = () => downloadProcurementFile(true);
  const handleDownloadPurchaseOrder = async () => {

    if (operation.current || loading || listError || !liveSeq) return;
    if (page === "order-done" && selectedBatchRound !== "all" && displayList.length === 0) { await downloadProcurementFile(false); return; }
    operation.current = "export"; setLoading_(true); setActionError("");
    const currentContext = context;
    try {
      const targets = selectOrder.length > 0
        ? displayList.map(order => ({ ...order, order_details: order.order_details.filter(detail => selectOrder.includes(detail.detail_seq)) }))
          .filter(order => order.order_details.length > 0)
        : await fetchAllMatchingOrders();
      const giftOrders = await withSellerGifts(targets, liveSeq, giftProcurementSeq, selectOrder.length === 0);
      if (mounted.current && currentContext === contextRef.current) downloadPurchaseOrder(giftOrders.orders, ...(giftOrders.gifts.items.length || giftOrders.gifts.unavailable ? [giftOrders.gifts] : []));
    } catch (cause: any) {
      if (mounted.current && currentContext === contextRef.current) setActionError(cause?.message || "발주서를 다운로드하지 못했습니다.");
    } finally {
      operation.current = null;
      if (mounted.current) setLoading_(false);
    }
  };

  const saveOrderBatchMemo = async (round: number, name: string, memo: string) => {
    if (!canManageOrders) return;
    if (operation.current) return;
    operation.current = "memo"; setLoading_(true); setActionError("");
    const currentContext = context;
    try {
      await api.patch(url.Communication_url.procurement_memo, {
        live_seq: liveSeq,
        round,
        name,
        memo,
      }, { headers: { "Content-Type": "application/json" } });
      if (!mounted.current || currentContext !== contextRef.current) return;
      await loadOrderBatches();
      setMemoModalRound(null);
    } catch (e) {
      if (mounted.current && currentContext === contextRef.current) setActionError("발주 메모를 저장하지 못했습니다. 입력 내용은 유지됩니다.");
    } finally {
      operation.current = null;
      if (mounted.current) setLoading_(false);
    }
  };

  const saveCompletedBatch = async (round: number, name: string, memo: string) => {
    if (operation.current) return;
    operation.current = 'procurement-meta'; setCompletionSaving(true); setLoading_(true); setActionError('');
    const currentContext = context;
    try {
      await api.patch(url.Communication_url.procurement_memo, { live_seq: liveSeq, round, name, memo },
        { headers: { 'Content-Type': 'application/json' } });
      if (!mounted.current || currentContext !== contextRef.current) return;
      await loadOrderBatches();
      setShowPurchaseOrderDone(false); setPendingProcurementRound(null);
      const giftOrders = await withSellerGifts(pendingPurchaseOrdersRef.current, liveSeq, orderBatches.find(batch => batch.round === round)?.procurementSeq);
      if (mounted.current && currentContext === contextRef.current) downloadPurchaseOrder(giftOrders.orders, ...(giftOrders.gifts.items.length || giftOrders.gifts.unavailable ? [giftOrders.gifts] : []));
    } catch (cause: any) {
      if (mounted.current && currentContext === contextRef.current)
        setActionError(cause?.response?.data?.message || '발주명과 메모를 저장하지 못했습니다. 입력 내용은 유지됩니다.');
    } finally { operation.current = null; if (mounted.current) { setCompletionSaving(false); setLoading_(false); } }
  };

  // "발주완료" 전용 처리 — 새 회차 생성 + 상태변경 API + "발주처리 완료(발주서 다운?)" 모달.
  // update_order_detail(공용, 다른 상태변경에서도 씀)은 자체 alert가 있어서 커스텀 모달과 안 맞아
  // 별도로 뺐다(주문취소 리뷰 흐름과 동일한 이유).
  const submit발주완료 = async (targetSeqs: number[], all = false) => {
    if (!canManageOrders) return;
    if (operation.current || loading || listError || !liveSeq) return;
    if (!["결제대기", "결제완료"].includes(pagename)) {
      setActionError("결제대기 또는 결제완료 주문만 발주 처리할 수 있습니다."); return;
    }
    operation.current = "procurement";
    setLoading_(true);
    setActionError(""); setActionMessage("");
    const currentContext = context;
    try {
      // list가 reload되기 전(=아직 이 탭에 남아있는 시점)에 발주서용 원본을 미리 스냅샷.
      const snapshot = (all ? await fetchAllMatchingOrders() : list)
        .map((order) => ({
          ...order,
          order_details: order.order_details.filter((d) =>
            all || targetSeqs.includes(d.detail_seq)
          ),
        }))
        .filter((order) => order.order_details.length > 0);

      if (!mounted.current || currentContext !== contextRef.current) return;
      const snapshotSeqs = snapshot.flatMap(order => order.order_details.map(detail => detail.detail_seq));
      if (snapshotSeqs.length === 0) { setShowSelectRequired(true); return; }
      const { data } = await api.patch(
        all ? url.Communication_url.update_all_order_status : url.Communication_url.order_detail_update_procurement,
        all ? { ...matchingParams(), current_status: pagename, change_status: "발주완료" }
          : { detail_seq_list: targetSeqs, current_status: pagename },
        { headers: { "Content-Type": "application/json" } }
      );
      if (!mounted.current || currentContext !== contextRef.current) return;
      const success = Number(data?.success);
      if (!isCount(data?.success) || !Array.isArray(data.rounds)) throw new Error("발주 처리 결과를 확인하지 못했습니다. 주문 상태를 다시 확인해주세요.");
      const successfulIds: number[] = Array.isArray(data.success_detail_seqs) ? data.success_detail_seqs
        : success === snapshotSeqs.length ? snapshotSeqs : [];
      const successfulSet = new Set(successfulIds);
      const confirmedOrders = snapshot.map(order => ({ ...order, order_details: order.order_details.filter(detail => successfulSet.has(detail.detail_seq)) }))
        .filter(order => order.order_details.length > 0);
      cnt_reload();
      await Promise.all([loadOrderBatches(), get_order_list(1)]);
      if (!mounted.current || currentContext !== contextRef.current) return;
      setSelectOrder([]);
      setSelect_status("");
      if (success === 0) {
        setActionError([...new Set(data.failures?.map((failure: any) => failure.message).filter(Boolean))].join(" ") || "발주 처리된 주문이 없습니다. 주문 상태를 확인해주세요.");
      } else {
        setActionMessage(`발주 처리 ${success}건 완료${Number(data.fail) > 0 ? ` (실패 ${data.fail}건)` : ""}`);
        if (successfulIds.length !== success || confirmedOrders.reduce((sum, order) => sum + order.order_details.length, 0) !== success) {
          setActionError("처리된 주문을 모두 확인하지 못했습니다. 발주완료 탭에서 발주서를 다운로드해주세요.");
        } else {
          pendingPurchaseOrdersRef.current = confirmedOrders;
          setPendingProcurementRound(Number(data.rounds[0]?.round) || null);
          operation.current = null;
          setLoading_(false);
          setShowPurchaseOrderDone(true);
        }
      }
    } catch (cause: any) {
      if (mounted.current && currentContext === contextRef.current) setActionError(cause?.response?.data?.message || cause?.message || "발주 처리 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      operation.current = null;
      if (mounted.current) setLoading_(false);
    }
  };

  const set주문상태 = (order_status: string) => {
    if (!canManageOrders) return;
    if (loading_ || operation.current || loading || listError) return;
    if (select_status !== "") return order_status === "발주완료"
      ? submit발주완료([], true) : update_all_order_status(order_status);
    if (selectOrder.length === 0) {
      setShowSelectRequired(true);
      return;
    }
    if (testOrder.enabled && selectOrder.includes(TEST_DETAIL_SEQ) && !['결제대기', '결제완료', '배송완료'].includes(order_status)) {
      setActionError('테스트 주문은 결제완료·배송완료 처리와 취소·환불 시험에 사용해주세요.'); return;
    }
    if (order_status === "발주완료") {
      submit발주완료([...selectOrder]);
      return;
    }
    if (
      ["환불처리"].includes(order_status) &&
      !window.confirm(
        `해당 주문을 ${order_status} 하시겠습니까?\n${order_status} 후 되돌릴 수 없습니다.`
      )
    ) {
      return;
    }
    const data = {
      detail_seq_list: selectOrder,
      current_status: pagename,
      change_status: order_status,
    };

    update_order_detail(data);
  };
  const set모든주문선택 = () => {
    if (total === 0) return;
    if (page === "order-done" && selectedBatchRound !== "all") {
      const ids = displayList.flatMap(order => order.order_details.map(detail => detail.detail_seq));
      setSelectOrder(previous => previous.length === ids.length ? [] : ids); setSelect_status(""); return;
    }
    if (select_status === "") {
      const menuname = pages.find((data) => data.key === page)?.name || "";
      setSelect_status(menuname);
      setSelectOrder([]);
    } else {
      setSelect_status("");
    }
  };
  const update_all_order_status = async (change_status: string) => {
    if (operation.current || loading_ || loading || listError) return;
    if (testOrder.enabled && testOrder.matches(select_status)) {
      if (list.some(order => order.seq !== TEST_ORDER_SEQ)) { setActionError('테스트 주문과 실제 주문은 따로 선택해 처리해주세요.'); return false; }
      try { testOrder.changeStatus(change_status); setSelect_status(''); go_page(pages.find(item => item.name === change_status)?.key || 'payment-wait'); return true; }
      catch (error: any) { setActionError(error.message); return false; }
    }
    if (change_status === "환불처리" && !window.confirm(`모두 ${change_status} 하시겠습니까?`)) return;
    operation.current = "status"; setLoading_(true); setActionError(""); setActionMessage("");
    try {
      const { data } = await api.patch(url.Communication_url.update_all_order_status,
        { ...matchingParams(), current_status: select_status, change_status, ...(change_status === "주문취소" ? { reason: cancelReason.trim(), request_id: cancelRequest.current } : {}) });
      if (![data?.total, data?.success, data?.fail].every(isCount)) throw new Error("상태 변경 결과를 확인하지 못했습니다. 주문 내역을 다시 확인해주세요.");
      if (Number(data.success) > 0) setActionMessage(`상태 변경 ${data.success}건 완료${Number(data.fail) > 0 ? ` (실패 ${data.fail}건)` : ""}`);
      if (Number(data.fail) > 0) setActionError([...new Set(data.failures?.map((failure: any) => failure.message).filter(Boolean))].join(" ") || "일부 주문의 상태를 변경하지 못했습니다.");
      cnt_reload(); await Promise.all([get_order_list(1), page === "order-done" ? loadOrderBatches() : Promise.resolve()]); if (!Number(data.fail)) { setSelectOrder([]); setSelect_status(""); }
      return Number(data.fail) === 0;
    } catch (error: any) {
      setActionError(orderActionError(error, "주문 상태를 변경하지 못했습니다. 다시 시도해주세요."));
      return false;
    } finally { operation.current = null; setLoading_(false); }
  };

  /* 엑셀 */
  const uploadRef = useRef<HTMLInputElement | null>(null);
  const clickBtn = () => {
    if (!canManageOrders) return;
    if (uploadRef.current) {
      uploadRef.current.click();
    }
  };
  const upload_xlxs = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!canManageOrders) return;
    if (operation.current || loading || listError || !liveSeq) return;
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const file = files[0];
    const currentContext = context;
    operation.current = "upload";
    setLoading_(true); setActionError(""); setActionMessage("");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("live_seq", String(liveSeq));
    try {
      const res = await api.post(url.Communication_url.delivery_excel_upload, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (!mounted.current || currentContext !== contextRef.current) return;
      const { total, success, fail, failures, tracking_enabled } = res.data || {};
      if (![total, success, fail].every(value => Number.isInteger(value) && value >= 0) || !Array.isArray(failures)) {
        throw new Error("송장 업로드 결과를 확인하지 못했습니다. 주문 상태를 다시 확인해주세요.");
      }
      setActionMessage(`송장 등록 ${success}건 · 실패 ${fail}건 (전체 ${total}건)${success > 0
        ? tracking_enabled ? " — 발송 준비로 표시되며 배송조회에서 집하가 확인되면 배송중으로 변경됩니다." : " — 발송 준비로 표시됩니다. 배송 자동 확인은 설정 후 사용할 수 있습니다."
        : ""}`);
      if (failures.length > 0) {
        setActionError({ uploadFailures: failures });
      }
      if (success > 0) {
        cnt_reload();
        await Promise.all([get_order_list(1), loadOrderBatches()]);
        if (mounted.current && currentContext === contextRef.current) { setSelectOrder([]); setSelect_status(""); }
      }
    } catch (cause: any) {
      if (mounted.current && currentContext === contextRef.current) setActionError(orderActionError(cause, "송장 파일을 업로드하지 못했습니다. 파일 형식을 확인해주세요."));
    } finally {
      operation.current = null;
      if (mounted.current) setLoading_(false);
      if (uploadRef.current) uploadRef.current.value = "";
    }
  };
  const downloadProductSales = async () => {
    if (operation.current || !liveSeq) return;
    operation.current = 'export-sales'; setLoading_(true); setActionError('');
    const currentContext = context;
    try {
      const { data } = await api.get(`${SERVER_ADDRESS}orders/live-product-sales`, { params: { live_seq: liveSeq } });
      if (!mounted.current || currentContext !== contextRef.current) return;
      downloadLiveProductSales(data?.items, liveSeq);
    } catch {
      if (mounted.current && currentContext === contextRef.current) setActionError('판매 상품 엑셀을 다운로드하지 못했습니다. 다시 시도해주세요.');
    } finally {
      operation.current = null;
      if (mounted.current) setLoading_(false);
    }
  };
  // 엑셀 내보내기
  const download_xlxs = async () => {

    if (operation.current || loading || listError || !liveSeq) return;
    if (page === "order-done" && selectedBatchRound !== "all" && displayList.length === 0) { await downloadProcurementFile(false); return; }
    operation.current = "export"; setLoading_(true); setActionError("");
    const currentContext = context;
    try {
      const { orders, gifts } = await withSellerGifts(await fetchAllMatchingOrders(), liveSeq, giftProcurementSeq);
      if (!mounted.current || currentContext !== contextRef.current) return;
      if (orders.length === 0) {
        if (isProcurementHistory) { await downloadSellerGiftHistory(liveSeq); return; }
        setActionMessage("다운로드할 주문건이 없습니다."); return;
      }
      XLSX_down_(orders, isProcurementHistory ? (selectedBatchRound === "all" ? "전체 발주 내역" : `${selectedBatchRound}차 발주 내역`) : pagename, ...(gifts.items.length || gifts.unavailable ? [gifts] : []));
    } catch (cause: any) {
      if (mounted.current && currentContext === contextRef.current) setActionError(cause?.message || "주문 엑셀을 다운로드하지 못했습니다.");
    } finally {
      operation.current = null;
      if (mounted.current) setLoading_(false);
    }
  };

  /* 주문 상태 변경 */
  const modify_memo = async (seq: number, type: string, data: string) => {
    if (!canManageOrders) return;
    if (type !== "admin_memo") return;
    if (testOrder.enabled && seq === TEST_DETAIL_SEQ) { testOrder.memo(data); return; }
    try {
      await api.patch(url.Communication_url.order_detail_memo, { detail_seq: seq, admin_memo: data },
        { headers: { "Content-Type": "application/json" } });
      setList(prev => prev.map(order => ({ ...order, order_details: order.order_details.map(detail =>
        detail.detail_seq === seq ? { ...detail, admin_memo: data } : detail) })));
    } catch (error) { alert("주문 메모를 저장하지 못했습니다. 다시 시도해주세요."); }
  };

  const update_order_detail = async (send_data: any, isGoGO?: boolean) => {
    if (!canManageOrders || operation.current || (selectOrder.length === 0 && !isGoGO)) return;
    if (testOrder.enabled && send_data.detail_seq_list?.includes(TEST_DETAIL_SEQ)) {
      if (send_data.detail_seq_list.length !== 1) { setActionError('테스트 주문과 실제 주문은 따로 선택해 처리해주세요.'); return false; }
      try { testOrder.changeStatus(send_data.change_status); setActionMessage("상태 변경 1건 완료"); setSelectOrder([]); go_page(pages.find(item => item.name === send_data.change_status)?.key || 'payment-wait'); return true; }
      catch (error: any) { setActionError(error.message); return false; }
    }
    operation.current = "status"; setLoading_(true); setActionError(""); setActionMessage("");
    try {
      const { data } = await api.patch(url.Communication_url.order_detail_update, send_data,
        { headers: { "Content-Type": "application/json" } });
      if (![data?.total, data?.success, data?.fail].every(isCount)) throw new Error("상태 변경 결과를 확인하지 못했습니다. 주문 내역을 다시 확인해주세요.");
      if (Number(data.success) > 0) setActionMessage(`상태 변경 ${data.success}건 완료${Number(data.fail) > 0 ? ` (실패 ${data.fail}건)` : ""}`);
      if (Number(data.fail) > 0) setActionError([...new Set(data.failures?.map((failure: any) => failure.message).filter(Boolean))].join(" ") || "일부 주문의 상태를 변경하지 못했습니다.");
      cnt_reload(); await Promise.all([get_order_list(1), page === "order-done" ? loadOrderBatches() : Promise.resolve()]); if (!Number(data.fail)) setSelectOrder([]);
      return Number(data.fail) === 0;
    } catch (error: any) {
      setActionError(orderActionError(error, "주문 상태를 변경하지 못했습니다. 다시 시도해주세요."));
      return false;
    } finally { operation.current = null; setLoading_(false); }
  };

  const order_delete = async () => {
    if (!canManageOrders || operation.current || loading_ || loading || listError) return;
    if (!selectOrder.length) { setShowSelectRequired(true); return; }
    if (testOrder.enabled && selectOrder.includes(TEST_DETAIL_SEQ)) { setActionError("테스트 주문은 테스트 주문 초기화 버튼을 사용해주세요."); return; }
    if (!window.confirm("정말로 삭제하시겠습니까?")) return;
    operation.current = "delete"; setLoading_(true); setActionError(""); setActionMessage("");
    try {
      const { data } = await api.delete(url.Communication_url.order_delete, { data: { detail_seq_list: selectOrder } });
      if (![data?.total, data?.success, data?.fail].every(isCount)) throw new Error("삭제 결과를 확인하지 못했습니다. 주문 내역을 다시 확인해주세요.");
      setActionMessage(`삭제 ${data.success}건 완료${Number(data.fail) > 0 ? ` (실패 ${data.fail}건)` : ""}`);
      if (Number(data.fail) > 0) setActionError([...new Set(data.failures?.map((failure: any) => failure.message).filter(Boolean))].join(" ") || "일부 주문을 삭제하지 못했습니다.");
      cnt_reload(); await get_order_list(1, true); setSelectOrder([]);
    } catch (error: any) {
      setActionError(orderActionError(error, "주문을 삭제하지 못했습니다. 다시 시도해주세요."));
    } finally { operation.current = null; setLoading_(false); }
  };

  const excelActions = (
    <ExcelActions aria-label="엑셀 작업">
      <input
        ref={uploadRef}
        type={"file"}
        aria-label="송장 엑셀 파일"
        accept=".xlsx,.xls"
        disabled={loading_ || loading || !!listError}
        onChange={upload_xlxs}
        style={{ display: "none" }}
      />
      {canManageOrders && show_엑셀업로드 && (
        <Btn className="outline" onClick={handleDownloadPurchaseOrder}>
          발주서 다운
        </Btn>
      )}
      {canManageOrders && show_엑셀업로드 && (
        <Btn className="red" onClick={clickBtn}>
          엑셀 업로드
        </Btn>
      )}
      {page === "order-done" && <DeliveryExcelGuide />}
      {page === 'order-done' && selectedBatchRound !== 'all' && <Btn className="outline" onClick={downloadProcurementOriginal} disabled={loading_}>
        {orderBatches.find(batch => batch.round === selectedBatchRound)?.snapshotAvailable ? '발주 원본 다운' : '현재 발주 자료 다운'}
      </Btn>}
      {show_엑셀내보내기 && (
        <Btn className="download" onClick={download_xlxs}>엑셀 내보내기</Btn>
      )}
      {canManageOrders && show_삭제 && <Btn onClick={order_delete}>삭제</Btn>}
    </ExcelActions>
  );

  return (
    <Layout_Admin menuname={"주문내역"} fixedContent>
      <OrderPage>
      <AdminPageHeader
        title="주문 내역"
        hideTitle
        className="order-page-header"
        titleAside={<LiveInfo>
          {liveInfo.img ? (
            <img src={liveInfo.img} alt="live" />
          ) : (
            <div className="thumb" />
          )}
          <div className="meta">
            <div className="title">{liveInfo.title}</div>
            <div className="date">
              {liveInfo.start} ~ {liveInfo.end}
            </div>
          </div>
        </LiveInfo>}
        onBack={() => Navigate("/admin/order-list")}
        actions={<>
          {excelActions}
          <HeaderAction $download type="button" disabled={!liveSeq || loading_} onClick={() => void downloadProductSales()}
            title="해당 방송의 전체 판매 상품을 추출합니다.">판매 상품 엑셀</HeaderAction>
          {canManageOrders && page === "payment-wait" && <AdminActionButton type="button" disabled={!liveSeq || loading_}
            onClick={() => setPaymentNoticeOpen(true)}>미결제자 결제 알림</AdminActionButton>}
          {canManageOrders && page === "delivery-done" && <HeaderAction type="button" disabled={!liveSeq} aria-expanded={cashReceiptsOpen}
            onClick={() => setCashReceiptsOpen(value => !value)}>무통장 현금영수증</HeaderAction>}
          {canManageOrders && !["payment-wait", "payment-done"].includes(page) && <HeaderAction type="button"
            disabled={deliveryBusy || !deliveryStatus?.enabled}
            title={deliveryStatus?.enabled ? '송장이 있는 미완료 주문 전체를 새로 조회합니다.' : '스마트택배 조회 API 설정 후 사용할 수 있습니다.'}
            onClick={refreshDeliveryNow}>배송 상태 갱신</HeaderAction>}
        </>}
      />

      {cashReceiptsOpen && canManageOrders && page === "delivery-done" && liveSeq > 0 && <BankCashReceiptList liveSeq={liveSeq} onClose={closeCashReceipts} />}
      {paymentNoticeOpen && canManageOrders && page === "payment-wait" && liveSeq > 0 && <SendPaymentModal
        visible handleModal={() => setPaymentNoticeOpen(false)} sendType="정산서" liveSeq={liveSeq} />}


      <TabAreaWrap>
        {pagename === "결제대기" && excessOrderCount > 0 && (
          <ExcessBubble>
            <span className="mark">!</span>
            시스템 오류로 인해 초과된 주문건이 존재합니다.
          </ExcessBubble>
        )}
        <Order_select_menu ref={menuRef} onErrorChange={setCountLoadError} go_page={go_page} testCounts={testOrder.counts} />
      </TabAreaWrap>

      {pagename === "발주완료" && (
        <BatchTabRow aria-busy={batchLoading}>
          <BatchTab
            className={selectedBatchRound === "all" ? "this" : ""}
            onClick={() => { if (!operation.current) { listRequest.current += 1; setSelectedBatchRound("all"); setBatchView('history'); } }}
          >
            전체
          </BatchTab>
          {orderBatches.map((batch) => {
            const { completedCount, totalCount } = batch;
            const complete = totalCount > 0 && completedCount === totalCount;
            return (
              <BatchTab
                key={batch.round}
                data-completion={complete ? "complete" : "pending"}
                role="button"
                tabIndex={0}
                aria-pressed={selectedBatchRound === batch.round}
                aria-label={`${batch.name}, 송장 등록 ${completedCount}건 / 전체 ${totalCount}건, ${complete ? "송장 등록 완료" : "미완료"}`}
                title={`송장 등록 ${completedCount}건 / 전체 발주 ${totalCount}건`}
                onKeyDown={event => {
                  if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) {
                    event.preventDefault();
                    if (!operation.current) { listRequest.current += 1; setSelectedBatchRound(batch.round); setBatchView('history'); }
                  }
                }}
                className={selectedBatchRound === batch.round ? "this" : ""}
                onClick={() => { if (!operation.current) { listRequest.current += 1; setSelectedBatchRound(batch.round); setBatchView('history'); } }}
              >
                <svg className="batch-status-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <path d={complete ? "m5 12 4 4L19 6" : "m6 6 12 12M18 6 6 18"} />
                </svg>
                {batch.name} ({completedCount}/{totalCount}) : {batch.createdAt}
                <BatchIcon
                  role="button"
                  aria-label={`${batch.round}차 발주 메모`}
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault(); event.stopPropagation(); setActionError(""); setMemoModalRound(batch.round);
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActionError("");
                    setMemoModalRound(batch.round);
                  }}
                >
                  {batch.memo ? <ChatIcon /> : <PencilIcon />}
                </BatchIcon>
              </BatchTab>
            );
          })}
        </BatchTabRow>
      )}

      {pagename === "발주완료" && batchError && <Feedback role="alert">{batchError} <button type="button" onClick={loadOrderBatches}>회차 다시 불러오기</button></Feedback>}

      <OrderFilters role="group" aria-label="주문 조회 및 상태 변경">
      <PaymentFilters role="group" aria-label={page === "order-done" ? "발주완료 주문 필터" : "결제 수단 필터"} $active={bankPending || !!paymentMethod || !!trackingFilter}>
        {page === "order-done" && <label>보기<select aria-label="발주 내역 보기" value={batchView} disabled={loading_}
          onChange={event => setBatchView(event.target.value as 'history' | 'pending')}>
          <option value="history">전체 발주 내역</option><option value="pending">현재 발주완료만</option>
        </select></label>}
        <FilterTitle><svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 6h16l-6.5 7.2V19l-3 1v-6.8L4 6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>필터</FilterTitle>
        <label>결제 수단<select aria-label="결제 수단" value={paymentMethod} disabled={loading_} onChange={event => {
          setPaymentMethod(event.target.value as '' | 'pg' | 'bank');
          if (event.target.value !== 'bank') setBankPending(false);
        }}><option value="">전체 결제 수단</option><option value="pg">PG 결제</option><option value="bank">무통장 입금</option></select></label>
        {page === "order-done" && <label>송장번호<select aria-label="송장번호 등록 여부" value={trackingNumber} disabled={loading_} onChange={event => {
          setTrackingNumber(event.target.value as '' | 'true' | 'false');
        }}><option value="">전체</option><option value="true">송장번호 있음</option><option value="false">송장번호 없음</option></select></label>}
        {canManageOrders && page === "payment-wait" && liveSeq > 0 && <DepositExcelImport key={liveSeq} liveSeq={liveSeq} disabled={loading_}
          onConfirmed={async () => { cnt_reload(); await get_order_list(1); }} />}
      {['claims','cancel','refund','payment-cancel'].includes(page) && <ClaimFilters>
        <label>접수 유형<select aria-label="취소·반품·환불 접수 유형" value={page === 'payment-cancel' ? 'automatic' : page === 'cancel' ? 'cancel' : page === 'refund' ? 'refund' : claimKind}
          onChange={event => { const value = event.target.value; setClaimStatus(''); setClaimRefundStatus(''); setTransferStatus(''); setClaimKind(value === 'automatic' ? '' : value); setCurrentPage(1); if (value === 'automatic') go_page('payment-cancel'); else if (page !== 'claims') go_page('claims'); }}>
          <option value="">전체</option><option value="cancel">취소</option><option value="return">반품</option><option value="refund">환불</option><option value="automatic">기한 초과 자동 취소</option>
        </select></label>
        <label>처리 상태<select aria-label="취소·반품·환불 처리 상태" disabled={page !== 'claims'} value={page === 'claims' ? claimStatus : ''}
          onChange={event => { setClaimStatus(event.target.value); setCurrentPage(1); }}><option value="">전체 상태</option>
          {CLAIM_PROCESSING_STATES.filter(([key])=>!claimKind||(claimKind==='return'?!['approved','completed'].includes(key):!['collecting','received'].includes(key))).map(([key,name])=><option key={key} value={key}>{name}</option>)}
        </select></label>
        <label>환불 상태<select aria-label="취소·반품·환불 환불 상태" value={transferStatus?`bank_${transferStatus}`:claimRefundStatus} disabled={page!=='claims'} onChange={event=>{
          const value=event.target.value;if(value.startsWith('bank_')){const transfer=value.slice(5);setTransferStatus(transfer);setClaimRefundStatus(transfer);}else{setTransferStatus('');setClaimRefundStatus(value);}setCurrentPage(1);
        }}><option value="">전체</option><optgroup label="환불">{CLAIM_REFUND_STATES.map(([key,name])=><option key={key} value={key}>{name}</option>)}</optgroup><optgroup label="무통장 송금"><option value="bank_pending">송금 대기</option><option value="bank_completed">송금 완료</option></optgroup></select></label>
      </ClaimFilters>}
      <DateFilters><label>시간 기준<select aria-label="시간 기준" value={dateType} disabled={loading_} onChange={event => setDateType(event.target.value)}>
        <option value="order">주문 시간</option><option value="paid">결제 시간</option><option value="deposit">입금 시간</option><option value="processed">마지막 처리 시간</option>
      </select></label><label>시작일<input aria-label="조회 시작일" type="date" value={startDate} max={endDate || undefined} disabled={loading_} onChange={event => setStartDate(event.target.value)} /></label>
        <span aria-hidden="true">~</span><label>종료일<input aria-label="조회 종료일" type="date" value={endDate} min={startDate || undefined} disabled={loading_} onChange={event => setEndDate(event.target.value)} /></label>
        {(startDate || endDate) && <button type="button" onClick={() => { setStartDate(''); setEndDate(''); }}>기간 초기화</button>}
      </DateFilters>
      </PaymentFilters>
      <FilterPanel $claims={page==='claims'} data-admin-search="">
        <SearchControls $claims={page==='claims'} role="search">
        <SearchBox>
          
          <RowView2>
            <select aria-label="검색 기준" value={searchKeyDraft} onChange={setting_search_key}>
              <option value={"order_name"}>주문자명</option>
              <option value={"order_nickname"}>닉네임</option>
              <option value={"addr_phone"}>연락처</option>
              <option value="product_name">상품명</option>
              <option value="order_seq">주문번호</option><option value="detail_seq">주문상세번호</option>
            </select>
            <input
              aria-label="검색어"
              placeholder="검색어 입력"
              value={pre_search_value}
              onChange={setting_pre_search_value}
              onKeyDown={keyPress_keyword}
            />
            <CenterView as="button" type="button" data-admin-search-action="" className="btn" onClick={() => search()}>
              검색
            </CenterView>
            <Icon
              className="reset"
              role="button"
              aria-label="필터 초기화" tabIndex={0} onKeyDown={event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();reset();}}}
              src={require("../../../Image/ic_reset_black.png")}
              onClick={reset}
            />
          </RowView2>
        </SearchBox>
        <SearchBox>
          
          <RowView2 className={page === "order-done" ? "procurement-tools" : undefined}>
            <CenterView as="button" type="button"
              className="redbtn"
              onClick={() => setOpen_productList(true)}
            >
              <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Zm0 9L4 7.5M12 12l8-4.5M12 12v9M8 5.25l8 4.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>
              품목 선택
            </CenterView>
            
          </RowView2>

          <Product_list
            visible={open_productList}
            handleModal={handleOpen_productList}
            list={productNames}
            selectedItems={search_item}
            setSearch_item={setSearch_item}
            loading={loading}
            error={listError}
          />
        </SearchBox>
        </SearchControls>
        {page==='claims'&&<ClaimActionPanel ref={setClaimActionContainer}/>}
      <OrderToolbar role="region" aria-label="주문 상태 변경 도구">
        {canManageOrders && !isProcurementHistory && (page !== "claims" && page !== "refund" && page !== "payment-cancel" && pagename !== "전체" ? (
          <OrderStatusArea className={loading_ ? "loading" : ""}>
            <div className="title">주문 상태 변경</div>

            {cancelMode ? (
              <>
                <StatusButton type="button" $tone="danger" disabled={loading_} onClick={clickCancelComplete}>
                  {/* {selectOrder.length}건 {cancelFlowStatus} 완료하기 */}
                  {selectOrder.length}건 {cancelFlowStatus} 완료하기
                </StatusButton>
                <StatusButton type="button" $showArrow={false} disabled={loading_} onClick={exitCancelReviewMode}>취소</StatusButton>
              </>
            ) : (
              <>
                {statusMenuList.map((data, idx) => {
                  if (data === "발주완료" && !["결제대기", "결제완료"].includes(pagename)) return null;
                  return (
                    <StatusButton
                      key={idx}
                      style={pagename === data ? { display: "none" } : {}}
                      type="button"
                      $tone={data === primaryStatusByPage[page] ? 'primary' : 'default'}
                      disabled={loading_}
                      onClick={() => set주문상태(data)}
                    >
                      {data}
                    </StatusButton>
                  );
                })}
                {pagename !== "주문취소" && <>
                  <StatusButton type="button" $tone="danger" disabled={loading_ || cancelSelectionBlocked}
                    title={cancelSelectionBlocked ? '결제대기 상품만 주문 취소할 수 있습니다.' : undefined} onClick={enterCancelReviewMode}>주문취소</StatusButton>
                  <StatusButton type="button" disabled={loading_ || page === 'payment-wait'} onClick={openReturnReview}>반품처리</StatusButton>
                </>}
                {pagename !== "주문취소" && isRefundFlow && (
                  <StatusButton type="button" $tone="danger" disabled={loading_} onClick={enterCancelReviewMode}>
                    {isRefundFlow ? "환불처리" : "주문취소"}
                  </StatusButton>
                )}
                {pagename !== "사고처리" && (
                  <StatusButton type="button" $tone="danger" disabled={loading_} onClick={() => set주문상태("사고처리")}>
                    사고처리
                  </StatusButton>
                )}
                <AllCheck
                  className={select_status ? "check" : ""}
                  onClick={set모든주문선택}
                >
                  <CheckBox
                    type={"checkbox"}
                    className="red"
                    checked={select_status !== ""}
                    readOnly
                  />
                  모든 주문 선택 ({total}건)
                </AllCheck>
                {pagename === "결제대기" && excessOrderCount > 0 && (
                  <AllCheck
                    className={showExcessOnly ? "check" : ""}
                    onClick={toggle_excess_only}
                  >
                    <CheckBox
                      type={"checkbox"}
                      className="red"
                      checked={showExcessOnly}
                      readOnly
                    />
                    초과 주문된 주문건 보기 ({excessOrderCount}건)
                  </AllCheck>
                )}
              </>
            )}
          </OrderStatusArea>
        ) : (
          null
        ))}

        
      </OrderToolbar>
      </FilterPanel>
      </OrderFilters>
      {(search_value || search_item.length > 0) && <SearchKeyword>
        {search_value && (
          <>
            <span>{search_value}</span>
            <Icon
              src={require("../../../Image/ic_x_gray.png")}
              onClick={del_search_value}
            />
          </>
        )}
        {search_item.map(name => (
          <span key={name} className="product-keyword">
            <span>{name}</span>
            <button type="button" aria-label={`${name} 선택 해제`} onClick={() => del_search_item(name)}>×</button>
          </span>
        ))}
      </SearchKeyword>}

      {testOrder.enabled && <Feedback role="status">[테스트]
        <button type="button" onClick={() => { testOrder.reset(); go_page('payment-wait'); }}>테스트 주문 초기화</button>
      </Feedback>}


      <OrderActionToast message={loadingError||actionMessage} persistent={!!loadingError} onDismiss={loadingError?undefined:dismissActionMessage} retryLabel={listError?"주문 다시 불러오기":countLoadError?"건수 다시 불러오기":"연계 내역 다시 불러오기"} onRetry={loadingError?()=>{if(listError)void get_order_list(currentPage);else if(countLoadError)menuRef.current?.get_order_count();else setGiftRevision(value=>value+1);}:undefined} />
      {actionError && (typeof actionError === "object" && "uploadFailures" in actionError
        ? <DeliveryExcelErrors failures={actionError.uploadFailures} />
        : <Feedback role="alert">{typeof actionError === "string" ? actionError : "처리 중 오류가 발생했습니다. 다시 시도해주세요."}</Feedback>)}
      

      <TableArea className="order-table-area"><SellerGiftList quietLoading onLoadError={setGiftLoadError} refreshKey={giftRevision} liveSeq={liveSeq} procurementSeq={giftProcurementSeq} orders={displayList} inlineOrders>


      <ScrollBox ref={orderScrollRef} role="region" aria-label="주문 목록" tabIndex={0}>




        {page==='claims'?<OrderClaimList actionContainer={claimActionContainer} onChanged={canManageOrders?()=>{void get_order_list(currentPage);cnt_reload();}:undefined} onBankRefund={canManageOrders?setBankRefundOrder:undefined} list={list} kind={claimKind} stage={claimStatus} refund={claimRefundStatus} transfer={transferStatus} onOpen={(seq,claimSeqs)=>{setClaimItemSeqs(undefined);setClaimSelectedSeqs(claimSeqs);setClaimOrder(seq);}} detailSeq={search_key === "detail_seq" && search_value ? Number(search_value) : undefined}/>:isProcurementHistory ? <Order_all onBankRefund={canManageOrders ? setBankRefundOrder : undefined} list={displayList} total={total} page="all" modify_memo={modify_memo} showProcurement /> : [
          "payment-wait",
          "payment-done",
          "order-done",
          "shipping",
          "delivery-done",
          "accident",
        ].includes(page) ? (
          <Order_paydeil
            onBankRefund={canManageOrders ? setBankRefundOrder : undefined}
            list={cancelMode ? cancelReviewList : displayList}
            total={total}
            selectOrder={selectOrder}
            setSelectOrder={setSelectOrder}
            modify_memo={modify_memo}
            select_status={select_status}
            setSelect_status={setSelect_status}
            page={page}
            liveInfo={liveInfo}
            cancelMode={cancelMode}
            cancelQtyMap={cancelQtyMap}
            onChangeCancelQty={changeCancelQty}
            cancelDeliveryMap={cancelDeliveryMap}
            onToggleCancelDelivery={toggleCancelDelivery}
            isAllCancelDeliveryChecked={isAllCancelDeliveryChecked}
            onSetAllCancelDelivery={setAllCancelDelivery}
            onRequestRemoveFromCancel={requestRemoveFromCancel}
            fullOrderList={list}
          />
        ) : (page === "cancel" || page === "payment-cancel") ? (
          <Order_cancel
            list={list}
            total={total}
            selectOrder={selectOrder}
            setSelectOrder={setSelectOrder}
            select_status={select_status}
            setSelect_status={setSelect_status}
            page={page}
          />
        ) : page === "refund" ? (
          <Order_refound
            onBankRefund={canManageOrders ? setBankRefundOrder : undefined}
            list={list}
            total={total}
            selectOrder={selectOrder}
            setSelectOrder={setSelectOrder}
            select_status={select_status}
            setSelect_status={setSelect_status}
            modify_memo={modify_memo}
            page={page}
          />
        ) : (
          <Order_all
            onBankRefund={canManageOrders ? setBankRefundOrder : undefined}
            list={list}
            total={total}
            selectOrder={selectOrder}
            setSelectOrder={setSelectOrder}
            select_status={select_status}
            setSelect_status={setSelect_status}
            page={page}
          />
        )}

        {loading && <Loding><div className="loading" /></Loding>}
      </ScrollBox>
      </SellerGiftList></TableArea>
      <TableFooter aria-label="주문 목록 하단">
        <span className="total">총 {total.toLocaleString()}건</span>
        <div className="pagination">
          {total > 0 && pageSize !== 'all' && <PageNavigation aria-label="주문 페이지">
            <button type="button" disabled={loading || currentPage <= 1} onClick={() => setCurrentPage(page => page - 1)}>이전</button>
            <span>{currentPage} / {Math.ceil(total / pageSize)}</span>
            <button type="button" disabled={loading || currentPage >= Math.ceil(total / pageSize)} onClick={() => setCurrentPage(page => page + 1)}>다음</button>
          </PageNavigation>}
        </div>
        <PageSizeLabel>표시 개수<select aria-label="목록 표시 개수" value={pageSize} disabled={loading_}
          onChange={event => setPageSize(event.target.value === 'all' ? 'all' : Number(event.target.value))}>
          {[100, 300, 500, 1000].map(size => <option key={size} value={size}>{size.toLocaleString()}개</option>)}<option value="all">전체</option>
        </select></PageSizeLabel>
      </TableFooter>
      {claimOrder && <OrderClaimDialog key={claimOrder} admin canManage={canManageOrders} initialView={claimItemSeqs?"request":"history"} initialClaimSeqs={claimSelectedSeqs} initialKind="return" initialDetailSeqs={claimItemSeqs} orderSeq={claimOrder} onClose={()=>setClaimOrder(null)} onChanged={()=>{void get_order_list(currentPage);cnt_reload();}} onBankRefund={()=>{setBankRefundOrder(claimOrder);setClaimOrder(null);}}/>}
      {bankRefundOrder && <BankRefundDialog orderSeq={bankRefundOrder} onClose={closeBankRefund}
        onConfirmed={async () => { cnt_reload(); if (await get_order_list(currentPage) === false) throw new Error("Order refresh failed"); }} />}
      <No_stock visible={stockModal} handleModal={handleStockModal} />

      <AdminCancellationDialog refundLayout={isRefundFlow} open={showCancelConfirm} title={isRefundFlow ? "관리자 환불처리" : "관리자 주문 취소"} reason={cancelReason} onReasonChange={setCancelReason}
        confirmLabel={isRefundFlow ? "환불 확정" : "취소하기"}
        description={`${select_status ? total : selectOrder.length}개 품목을 ${isRefundFlow ? "환불처리" : "취소"}합니다.`} busy={loading_} error={typeof actionError === 'string' ? actionError : ''}
        canConfirm={!isRefundFlow || (refundInputsValid && !!currentRefundQuote)}
        onClose={() => setShowCancelConfirm(false)} onConfirm={() => void submitCancelReview()}>
        {isRefundFlow && !select_status && <RefundAmountFields items={refundAmountItems} values={refundAmounts} disabled={loading_}
          onChange={(seq, value) => setRefundAmounts(previous => ({ ...previous, [seq]: value }))}
          onQuantityChange={(seq, quantity) => {
            setCancelQtyMap(previous => ({ ...previous, [seq]: Number(clampClaimQuantity(String(quantity), refundAmountItems.find(item => item.seq === seq)?.maxQuantity || 0, 1)) }));
            const order = refundSource.find(row => row.order_details.some(detail => detail.detail_seq === seq));
            if (order) setCancelDeliveryMap(previous => ({ ...previous, [order.seq]: false }));
            setRefundAmounts(previous => { const next = { ...previous }; delete next[seq]; return next; });
          }} />}
        {isRefundFlow && currentRefundQuote?.orders.filter(quote => quote.delivery_eligible_amount > 0).map(quote => <RefundDelivery key={quote.order_seq}>
          <input type="checkbox" aria-label={`주문 ${quote.order_seq} 배송비 환불`} checked={cancelDeliveryMap[quote.order_seq] ?? true} disabled={loading_}
            onChange={event => setCancelDeliveryMap(previous => ({ ...previous, [quote.order_seq]: event.target.checked }))} />
          주문 {quote.order_seq} 배송비 {quote.delivery_eligible_amount.toLocaleString('ko-KR')}원 환불
        </RefundDelivery>)}
        {isRefundFlow && needsRefundQuote && !currentRefundQuote && !refundQuoteError && <p role="status">환불 금액을 계산하고 있습니다.</p>}
        {isRefundFlow && refundQuoteError && <p role="alert">{refundQuoteError} <button type="button" onClick={() => setRefundQuoteRetry(value => value + 1)}>다시 계산</button></p>}
        {isRefundFlow && currentRefundQuote && <RefundTotal aria-live="polite">
          <p>상품 환불 {currentRefundQuote.orders.reduce((sum, quote) => sum + quote.goods_amount, 0).toLocaleString('ko-KR')}원</p>
          <p>배송비 환불 {currentRefundQuote.orders.reduce((sum, quote) => sum + quote.delivery_amount, 0).toLocaleString('ko-KR')}원</p>
          <strong aria-label="환불 총금액">환불 총금액 {currentRefundQuote.total_amount.toLocaleString('ko-KR')}원</strong>
        </RefundTotal>}

      </AdminCancellationDialog>
      <ConfirmModal
        visible={showCancelDone}
        title={`${cancelFlowStatus} 완료`}
        subtitle={`${cancelFlowStatus}가 완료되었습니다.`}
        onConfirm={() => setShowCancelDone(false)}
      />
      <ConfirmModal
        visible={removeTargetSeq !== null}
        title="환불 리스트 삭제"
        subtitle="해당 주문건을 삭제할까요?"
        onCancel={() => setRemoveTargetSeq(null)}
        onConfirm={confirmRemoveFromCancel}
      />
      <ConfirmModal
        visible={showRemoveDone}
        title="삭제 완료"
        subtitle="해당 리스트가 삭제되었습니다."
        onConfirm={() => setShowRemoveDone(false)}
      />
      <ConfirmModal
        visible={showSelectRequired}
        title="주문건을 선택해주세요."
        subtitle="상태 변경할 주문건을 선택해주세요."
        onConfirm={() => setShowSelectRequired(false)}
      />
      {showPurchaseOrderDone && <OrderBatchMemoModal visible round={pendingProcurementRound}
        existingName={pendingProcurementRound ? `${pendingProcurementRound}차 발주` : ''} existingMemo=""
        completion onSave={saveCompletedBatch} busy={completionSaving} error={typeof actionError === "string" ? actionError : ""}
        onClose={() => { if (!loading_) { setShowPurchaseOrderDone(false); setPendingProcurementRound(null); } }} />}
      <OrderBatchMemoModal
        visible={memoModalRound !== null}
        round={memoModalRound}
        existingName={orderBatches.find((b) => b.round === memoModalRound)?.name ?? `${memoModalRound ?? ''}차 발주`}
        existingMemo={
          orderBatches.find((b) => b.round === memoModalRound)?.memo ?? null
        }
        onSave={saveOrderBatchMemo}
        busy={loading_}
        error={typeof actionError === "string" ? actionError : ""}
        onClose={() => setMemoModalRound(null)}
      />
      </OrderPage>
    </Layout_Admin>
  );
};

export default Orderlist;

const OrderPage = styled.div`
  ${OrderTableHeader}{position:sticky;top:0;z-index:3;}
  --order-control-height: var(--control-sm);
  && [data-admin-tabs] > button { min-height: var(--order-control-height); height: var(--order-control-height); padding-block: 0; }
  @media (pointer: coarse) { --order-control-height: var(--touch-target); }
  @media(max-width:850px){&&{overflow:auto;overscroll-behavior:contain;}>.order-table-area{flex:0 0 55dvh;min-height:18rem;} >*{flex-shrink:0;}}

  display: flex; flex-direction: column; flex: 1; min-height: 0; min-width: 0; overflow: hidden;
  > * { min-width:0; }
  .order-page-header { position: static; flex-wrap: wrap; gap: var(--space-3); min-height: var(--control-lg); padding-bottom: var(--space-2); margin-bottom: var(--space-2); }
  .order-page-header::before { display: none; }
  .order-page-header h1 { white-space: nowrap; }
`;
const LiveInfo = styled.div`
  display: flex; align-items: center; gap: var(--space-3); min-width: 0; max-width: 28rem;
  img, .thumb { width: var(--control-lg); height: var(--control-lg); object-fit: cover; border-radius: var(--radius-md); flex-shrink: 0; }
  .meta { min-width: 0; }
  .title { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: var(--text-body); font-weight: var(--font-weight-semibold); color: var(--color-text-primary); }
  .date { font-size: var(--text-caption); color: var(--color-text-secondary); }
`;

const TabAreaWrap = styled.div`
  position: relative;
  [data-admin-tabs] { margin-bottom: 0; }
`;

const ExcessBubble = styled.div`
  position: absolute;
  left: 0;
  bottom: calc(100% + 10px);
  width: 11rem;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background-color: var(--admin-theme-danger-soft, #fdeaec);
  color: var(--admin-theme-danger, #eb003b);
  font-size: 13px;
  line-height: 1.4;
  font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  z-index: 5;
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 1.5rem;
    border: 7px solid transparent;
    border-top-color: var(--admin-theme-border, #fdeaec);
  }
  .mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #eb003b;
    color: white;
    font-size: 11px;
    font-family: var(--font-family-base); font-weight: var(--font-weight-bold);
    flex-shrink: 0;
  }
`;

const BatchTabRow = styled(RowView2).attrs<{ 'data-admin-tabs'?: string }>({ 'data-admin-tabs': '' })`
  flex-wrap: nowrap;
  margin-bottom: 0;
`;
const Feedback = styled.div`
  margin: 12px 0; font-size: 14px; line-height: 1.6;
  &[role='alert'] { color: var(--admin-theme-danger, #b42318); }
  button { margin-left: 8px; cursor: pointer; }
`;
const BatchTab = styled.div.attrs<{ 'data-admin-tab'?: string }>({ 'data-admin-tab': '' })`
  display: flex;
  align-items: center;
  gap: var(--gap-icon);
  flex-shrink: 0;
  height: var(--control-md);
  min-height: var(--touch-target);
  box-sizing: border-box;
  padding: 0 var(--space-4);
  margin-right: var(--space-2);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--text-body);
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  cursor: pointer;
  &.this {
    color: var(--color-text-primary);
    background: var(--color-brand-subtle);
    border-color: var(--color-text-primary);
  }
  .batch-status-icon {
    width: var(--space-4);
    height: var(--space-4);
    flex-shrink: 0;
    color: var(--color-text-danger);
  }
  &[data-completion='complete'] .batch-status-icon {
    color: var(--color-text-info);
  }
  &:focus-visible { box-shadow: var(--shadow-focus); }
`;
const BatchIcon = styled.span`
  display: inline-flex;
  color: inherit;
  cursor: pointer;
`;

const OrderFilters = styled.div`
  box-sizing: border-box; display: flex; flex-direction: column; min-width: 0;
  gap: var(--space-2); margin: var(--space-2) 0 0;
`;
const PaymentFilters = styled.div<{ $active: boolean }>`
  display: flex; align-items: center; flex-wrap: wrap; gap: var(--space-2); margin: 0;
  min-width: 0;
  box-sizing: border-box; padding: var(--space-1) var(--space-3);
  min-height: calc(var(--order-control-height) + var(--space-3) + var(--space-2) + 2px);
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-subtle);
  > * { min-width:0; }
  button { height: var(--order-control-height, var(--control-sm)); min-height: var(--order-control-height, var(--control-sm)); padding-block: 0; }
  label { display: flex; align-items: center; flex: 0 0 auto; gap: var(--space-2); min-height: var(--order-control-height, var(--control-sm)); white-space: nowrap; color: var(--color-text-secondary); font-size: var(--text-caption); font-weight: var(--font-weight-medium); }
  select { font: inherit; font-size: var(--text-body); font-weight: var(--font-weight-regular); min-height: var(--order-control-height, var(--control-sm)); padding: 0 var(--space-3); background: var(--color-bg-surface); color: var(--color-text-primary); border: 1px solid var(--color-border-default); border-radius: var(--radius-md); }
`;
const FilterTitle = styled.strong`
  display: inline-flex; align-items: center; gap: 7px; margin-right: 2px;
  color: var(--admin-theme-link, #4c3677); font-size: 14px; white-space: nowrap;
`;
const FilterPanel = styled.div<{ $claims?: boolean }>`
  display:flex;flex-wrap:wrap;gap:var(--space-3);align-items:stretch; >[role="search"]{flex:0 1 38rem;} >[role="region"]{flex:1 1 38rem;}
  @media (max-width: 1000px) { grid-template-columns: minmax(0, 1fr); }
`;
const SearchControls = styled.div<{ $claims?: boolean }>`
  box-sizing: border-box; display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: center;
  gap: var(--space-3); min-width: 0; padding: var(--space-1) var(--space-3);
  min-height: calc(var(--order-control-height) + var(--space-3) + var(--space-2) + 2px);
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-subtle);
  @media (max-width: 1000px) { grid-template-columns:minmax(0,1fr); }
`;
const ClaimActionPanel = styled.div`
  box-sizing:border-box;flex:1 1 40rem;min-width:0;padding:var(--space-1) var(--space-3);
  border:1px solid var(--color-border-default);border-radius:var(--radius-md);background:var(--color-bg-subtle);
  >div{background:transparent;padding-block:0;min-height:var(--control-lg);}
`;
const PageSizeLabel = styled.label`
  justify-self: end;
  display: flex; align-items: center; gap: var(--space-2); white-space: nowrap;
  color: var(--color-text-secondary); font-size: var(--text-caption);
  select { min-height: var(--order-control-height, var(--control-sm)); padding: 0 var(--space-3); border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; }
`;
const SearchBox = styled.div`
  .procurement-tools { gap: var(--space-2); flex-wrap: wrap; }
  .procurement-tools > .redbtn { flex-shrink: 0; box-sizing: border-box; height: var(--order-control-height); }
  position: relative;
  min-width: 0;
  margin-bottom: 0;
  div.label {
    margin-bottom: 0.5rem;
    ${fontStyles.semiBold}
    font-size: 18px;
  }
  select {
    height: var(--order-control-height, var(--control-sm));
    padding: 0rem 1rem;
    margin-right: 0.5rem;
    font-size: var(--text-body);
    border: 1px solid var(--admin-theme-border, #f0f0f0);
    border-radius: 8px;
    cursor: pointer;
    &:hover,
    &:focus {
      border: 1px solid var(--admin-theme-focus, #454545);
    }
  }
  input {
    box-sizing: border-box;
    flex: 1;
    min-width: 0;
    height: var(--order-control-height, var(--control-sm));
    padding: 0 var(--space-3);
    font-size: var(--text-body);
    border: 1px solid var(--admin-theme-border, #f0f0f0);
    border-radius: 8px;
    &:hover,
    &:focus {
      border: 1px solid var(--admin-theme-focus, #454545);
    }
  }
  span.wave {
    ${fontStyles.medium}
    margin: 0 1rem;
  }
  button.redbtn {
    box-sizing:border-box;min-width:7rem;height:var(--order-control-height);padding:0 var(--space-3);gap:var(--space-2);flex-shrink:0;
    border:1px solid var(--color-brand);border-radius:var(--radius-md);background:var(--gradient-brand);color:var(--color-text-on-brand);font:inherit;font-weight:var(--font-weight-semibold);white-space:nowrap;cursor:pointer;
    svg{width:var(--space-5);height:var(--space-5);flex:none;}
    &:hover{background:var(--gradient-brand-hover);border-color:var(--color-brand-hover);}
    &:focus-visible{outline:2px solid var(--color-focus-ring);outline-offset:2px;}
  }
  button.btn {
    box-sizing:border-box;width:4rem;height:var(--order-control-height);padding:0 var(--space-2);margin-left:var(--space-2);flex-shrink:0;
    border:1px solid var(--color-brand);border-radius:var(--radius-md);background:var(--gradient-brand);color:var(--color-text-on-brand);font:inherit;font-weight:var(--font-weight-semibold);cursor:pointer;
  }
  img.reset {
    box-sizing: border-box; width: var(--order-control-height); height: var(--order-control-height); padding: var(--space-1);
    margin-left: 0.5rem;
    border: 1px solid var(--admin-theme-border, #f0f0f0);
    border-radius: 8px;
    cursor: pointer;
  }
  @media (max-width: 680px) {
    ${RowView2} { flex-wrap: wrap; gap: 0.5rem; }
    select { margin-right: 0; }
    input { flex-basis: calc(100% - 9rem); }
    button.btn, img.reset { margin-left: 0; }
  }
`;
const SearchKeyword = styled(RowView2)`
  flex-wrap: wrap;
  gap: 8px;
  .product-keyword { display: inline-flex; align-items: center; gap: 5px; }
  button { min-width: 32px; min-height: 32px; border: 0; border-radius: 6px; background: transparent; color: inherit; font: inherit; cursor: pointer; }
  button:focus-visible { outline: 2px solid var(--admin-accent); outline-offset: 2px; }
  margin: var(--space-2) 0 0;
  white-space: nowrap;
  img {
    width: 24px;
    margin-left: 5px;
    margin-right: 1rem;
    cursor: pointer;
  }
`;
const OrderStatusArea = styled(RowView2)`
  flex-wrap: nowrap; flex: 0 0 auto; min-width: max-content;
  gap: var(--space-1); padding: 0;
  border: 0; background: transparent;
  white-space: nowrap;
  > * { min-width:0; }
  div.title {
    display: flex; align-items: center; gap: var(--space-2); margin: 0 var(--space-2) 0 0;
    color: var(--color-text-primary); font-size: var(--text-body); font-weight: var(--font-weight-bold);

  }
`;
const StatusButton = styled.button<{ $tone?: 'default' | 'primary' | 'danger'; $showArrow?: boolean }>`
  display: inline-flex; align-items: center; justify-content: center;
  min-height: var(--control-sm); padding: 0 var(--space-3); border-radius: var(--radius-md);
  border: 1px solid ${props => props.$tone === 'primary' ? 'var(--color-brand)' : 'var(--color-border-default)'};
  background: ${props => props.$tone === 'primary' ? 'var(--color-brand)' : props.$tone === 'danger' ? 'var(--color-danger-subtle)' : 'var(--color-bg-surface)'};
  color: ${props => props.$tone === 'primary' ? 'var(--color-text-on-brand)' : props.$tone === 'danger' ? 'var(--color-danger-strong)' : 'var(--color-text-primary)'};
  cursor: pointer; font: inherit; font-size: var(--text-body); font-weight: var(--font-weight-medium);
  &:hover:not(:disabled) { border-color: var(--color-brand); background: var(--color-brand-subtle); color: var(--color-text-link); }
  &:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: default; }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { min-height: var(--touch-target); }
`;
const AllCheck = styled(RowView2)`
  ${fontStyles.medium};
  color: var(--admin-muted);
  cursor: pointer;
  input {
    margin-right: 0.5rem;
    background-color: var(--admin-theme-raised, #e7e7e7);
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
  }
  &.check {
    color: var(--admin-theme-danger, #eb003b);
  }
`;
const OrderToolbar = styled(RowView)`
  flex: 0 0 auto; flex-wrap: nowrap; align-items: center; min-width: 0; width: 100%;
  box-sizing: border-box; padding: var(--space-1) var(--space-3);
  min-height: calc(var(--order-control-height) + var(--space-3) + var(--space-2) + 2px);
  overflow-x: auto; background: var(--color-bg-subtle); scrollbar-width: thin;
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
  &:empty { display: none; }
  &:not(:empty) { margin: 0; }
`;
const ExcelActions = styled(RowView2)`
  margin-left: auto;
  flex-wrap: wrap; align-items: center; gap: var(--space-2);
`;
const Btn = styled(ExcelButton)`
  &.download { color: var(--color-text-link); background: var(--color-brand-subtle); border-color: var(--color-brand); }
  &.download:hover:not(:disabled) { background: var(--color-brand); color: var(--color-text-on-brand); }

  &.red {
    color: var(--color-text-on-brand); background: var(--gradient-brand); border-color: transparent;
    &:hover { background: var(--gradient-brand-hover); }
  }
  &.outline { color: var(--color-text-link); border-color: var(--color-brand); }
`;
const Loding = styled(CenterView)`
  height: 3rem;
  color: var(--admin-theme-muted, #858585);
  div.loading {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 3px solid rgba(0, 0, 0, 0.3);
    border-top-color: #000000;
    border-radius: 100%;
    animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;
const TableArea = styled.div`
  display: flex; flex-direction: column; flex: 1 1 0%; min-width: 0; min-height: 0;
  overflow: hidden; margin-top: var(--space-2);
`;
const ScrollBox = styled.div`
  width: 100%; flex: 1 1 auto; min-height: 0; overflow: auto; overscroll-behavior: contain;
  scrollbar-gutter: stable;
`;
const PageNavigation = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: var(--space-2) 0 0;
  color: var(--admin-theme-text, #444);
  font-size: 0.9rem;
  button {
    min-width: 4.5rem;
    height: 2.4rem;
    border: 1px solid var(--admin-theme-border, #d9d2ef);
    border-radius: 6px;
    background: var(--admin-theme-surface, white);
    color: var(--admin-theme-link, #6541cf);
    cursor: pointer;
  }
  button:disabled { color: var(--admin-theme-muted, #aaa); border-color: var(--admin-theme-border, #eee); cursor: not-allowed; }
`;

const ClaimFilters=styled.div`display:contents;select{width:auto;}label{display:flex;align-items:center;gap:var(--space-2);font-size:var(--text-body);color:var(--color-text-primary);}select{min-height:var(--order-control-height);padding:0 var(--space-2);border:1px solid var(--color-border-default);border-radius:var(--radius-sm);background:var(--color-bg-surface);color:var(--color-text-primary);font:inherit;}`;

const DateFilters = styled.div`
  display:contents;
  input, select, button { min-height: var(--order-control-height, var(--control-sm)); min-width: 0; box-sizing: border-box; padding: 0 var(--space-3); border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; }
  input { color-scheme: inherit; } button { cursor: pointer; }
`;
const RefundDelivery = styled.label`
  display: flex; align-items: center; gap: var(--space-2); padding: var(--space-3) 0; border-top: 1px solid var(--color-border-default);
  color: var(--color-text-primary); font-size: var(--text-body); input { accent-color: var(--color-brand); }
`;
const RefundTotal = styled.div`
  display: grid; gap: var(--space-2); margin-block: var(--space-3) var(--space-5); padding: var(--space-4);
  border-radius: var(--radius-md); background: var(--color-bg-muted); font-variant-numeric: tabular-nums;
  p { margin: 0; color: var(--color-text-secondary); font-size: var(--text-body); }
  strong { display: block; padding-top: var(--space-2); border-top: 1px solid var(--color-border-default); color: var(--color-text-primary); font-size: var(--text-body-lg); }
`;

const HeaderAction = styled(AdminActionButton)<{ $download?: boolean }>`
  && { color: ${p => p.$download ? 'var(--color-text-link)' : 'var(--color-text-primary)'};
    background: ${p => p.$download ? 'var(--color-brand-subtle)' : 'var(--color-bg-elevated)'};
    border-color: ${p => p.$download ? 'var(--color-brand)' : 'var(--color-border-strong)'}; }
  &&:hover:not(:disabled), &&[aria-expanded="true"] { background: var(--color-brand-subtle); border-color: var(--color-brand); color: var(--color-text-link); }
  &&:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); border-color: var(--color-border-default); }
`;

const TableFooter = styled.div`
  flex: 0 0 auto; display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; gap: var(--space-3);
  padding-top: var(--space-2); font-variant-numeric: tabular-nums; font-size: var(--text-caption); color: var(--color-text-secondary);
  .total { justify-self: start; white-space: nowrap; }
  .pagination { justify-self: center; }
  nav { padding: 0; }
  @media (max-width: 640px) { grid-template-columns: auto 1fr; .pagination { grid-column: 1 / -1; grid-row: 2; } }
`;
